// EN
export const locale = {
    "seoExtra": {
        "ogImage": "Social Share Image (URL)",
        "ogImageHint": "Image shown when the page is shared on social media. If empty, the default/auto image is used.",
        "canonical": "Canonical URL",
        "canonicalHint": "The preferred (canonical) address of this page. If empty, the page's own URL is used.",
        "noIndex": "Hide from search engines (noindex)",
        "hideSitemap": "Exclude from sitemap",
        "advanced": "Advanced SEO"
    },
    "extra": {
        "customerGroups": "Customer Groups",
        "b2bStatus": "B2B Status",
        "b2bNone": "Not B2B",
        "b2bApproved": "Approved",
        "b2bPending": "Pending Approval",
        "b2bRejected": "Rejected",
        "skuBarcodeWeight": "SKU / Barcode / Weight",
        "weightG": "Weight (g)",
        "langNameExample": "e.g. English",
        "currencyNameExample": "e.g. US Dollar",
        "appSearch": "Search apps (shipping, payment...)",
        "yourStore": "YOUR STORE"
    },
    "common": {
        "comingSoon": {
            "badge": "Coming Soon",
            "heading": "This module will be here very soon!",
            "description": "We are working on this feature and it will be available to you soon. Thank you for your interest."
        },
        "accessDenied": {
            "title": "You don't have access to this area",
            "description": "You do not have the required permission to view this page. If you need access, please contact your system administrator.",
            "goBack": "Go Back",
            "goDashboard": "Go to Dashboard"
        },
        "edit": "Edit",
        "yes": "Yes",
        "no": "No",
        "new": "New",
        "back": "Back",
        "language": "Language",
        "currency": "Currency",
        "cancel": "Cancel",
        "send": "Send",
        "confirm": "Continue",
        "date": "Date",
        "save": "Save",
        "report": "Report",
        "active": "Active",
        "passive": "Inactive",
        "remove": "Delete",
        "action": "Action",
        "search": "Search",
        "all": "All",
        "startDate": "Start Date",
        "endDate": "End Date",
        "close": "Close",
        "preview": "Preview",
        "today": "Today",
        "weekly": "Weekly",
        "monthly": "Monthly",
        "yearly": "Yearly",
        "viewAll": "View All",
        "notification": "Notification",
        "download": "Download",
        "optional": "Optional",
        "permission": "Permission",
        "manager": "Manager",
        "default": "Default",
        "status": "Status",
        "sort": "Sort",
        "createdAt": "Created At",
        "chooseSelect": "Make a selection.",
        "chooseDate": "Select a date.",
        "chooseTime": "Select a time.",
        "chooseDateAndTime": "Select a date and time.",
        "selectGroup": "Please select a group.",
        "individual": "Individual",
        "corporate": "Corporate",
        "cash": "Cash",
        "system": "System",
        "export": "Export",
        "overview": "Overview",
        "settings": "Settings",
        "enable": "Enable",
        "homePage": "Home",
        "id": "ID",
        "true": "True",
        "false": "False",
        "hour": "Hour",
        "minute": "Minute",
        "second": "Second",
        "empty": "Empty",
        "indefinite": "Unlimited",
        "changePassword": "Change Password",
        "poster": "Featured Image",
        "you": "You",
        "min": "Minimum",
        "max": "Maximum",
        "start": "Start",
        "end": "End",
        "ip": "IP",
        "userAgent": "Browser Info",
        "selfLogin": "Log In to Account"
    },
    "menu": {
        "dashboard": {
            "title": "Dashboard",
            "description": "View the overall status and statistics of the system."
        },
        "ecommerce": {
            "title": "E-Commerce Management",
            "description": "Manage e-commerce processes and product management.",
            "product": {
                "title": "Products",
                "description": "View and manage products.",
                "list": {
                    "title": "Product List",
                    "description": "View the list of all products."
                },
                "buying": {
                    "title": "Purchasing",
                    "description": "Manage purchases made from suppliers."
                },
                "transfer": {
                    "title": "Transfers",
                    "description": "Manage product transfers between warehouses."
                },
                "stocks": {
                    "title": "Stock Count",
                    "description": "Manage product stock counting and inventory control operations."
                },
                "collation": {
                    "title": "Definitions",
                    "description": "Manage the definition settings required for product management.",
                    "category": {
                        "title": "Categories",
                        "description": "Create and manage product categories."
                    },
                    "brand": {
                        "title": "Brands",
                        "description": "Create and manage product brands."
                    },
                    "variant_types": {
                        "title": "Variant Types",
                        "description": "Create and manage product variant types."
                    },
                    "product_groups": {
                        "title": "Product Groups",
                        "description": "Create and manage product groups."
                    },
                    "suppliers": {
                        "title": "Suppliers",
                        "description": "Create and manage supplier information."
                    },
                    "tags": {
                        "title": "Tags",
                        "description": "Create and manage product tags."
                    },
                    "product_units": {
                        "title": "Product Units",
                        "description": "Create and manage product units."
                    },
                    "attribute": {
                        "title": "Custom Fields",
                        "description": "Manage attribute sets, custom fields and their options."
                    }
                },
                "priceList": {
                    "title": "Price List",
                    "description": "View and manage price lists for products."
                },
                "productBarcode": {
                    "title": "Product Barcode Label",
                    "description": "Create and print product barcode labels."
                }
            },
            "stock": {
                "title": "Stock Management",
                "description": "Manage warehouses, stock balances and stock processes.",
                "warehouses": {
                    "title": "Warehouses",
                    "description": "Define and manage warehouses, stores, and virtual warehouses."
                },
                "status": {
                    "title": "Stock Status",
                    "description": "View stock levels by warehouse, set thresholds and make adjustments."
                },
                "movements": {
                    "title": "Stock Movements",
                    "description": "View all stock in/out movements."
                },
                "purchases": {
                    "title": "Purchases",
                    "description": "Create supplier purchase orders and receive goods."
                },
                "transfers": {
                    "title": "Transfers",
                    "description": "Manage stock transfers between warehouses."
                },
                "counts": {
                    "title": "Stock Counts",
                    "description": "Create physical stock counts and adjust balances."
                }
            },
            "order": {
                "title": "Orders",
                "description": "View and manage order processes.",
                "list": {
                    "title": "Order List",
                    "description": "View all orders and manage order details."
                },
                "drafts": {
                    "title": "Drafts",
                    "description": "View and edit orders saved as drafts."
                },
                "abandonedCarts": {
                    "title": "Abandoned Carts",
                    "description": "View incomplete and abandoned cart transactions."
                },
                "cartLinks": {
                    "title": "Cart Links",
                    "description": "Manage cart sharing links."
                },
                "tags": {
                    "title": "Tags",
                    "description": "Create and manage order tags."
                },
                "giftCards": {
                    "title": "Gift Cards",
                    "description": "Create, edit and manage gift cards."
                },
                "statuses": {
                    "title": "Order Statuses",
                    "description": "Create and manage order status definitions."
                }
            },
            "customer": {
                "title": "Customers",
                "description": "Manage customer accounts and customer management processes.",
                "list": {
                    "title": "Customer List",
                    "description": "View all customers and manage customer information."
                },
                "pendingApproval": {
                    "title": "Pending Approval",
                    "description": "View and manage customer accounts in the approval process."
                },
                "customerGroups": {
                    "title": "Customer Groups",
                    "description": "Create and manage customer groups."
                },
                "tags": {
                    "title": "Tags",
                    "description": "Create and manage customer tags."
                }
            },
            "report": {
                "title": "Reports",
                "description": "View sales, order and system reports."
            },
            "salesChannels": {
                "title": "Sales Channels",
                "description": "Manage system-wide sales channels (Website, Mobile App, marketplaces…); orders are reported by channel."
            },
            "marketing": {
                "title": "Marketing",
                "description": "Manage marketing tools and campaign management processes.",
                "summary": {
                    "title": "Summary",
                    "description": "View general statistics on marketing performance."
                },
                "emailSms": {
                    "title": "Email & SMS",
                    "description": "Manage email and SMS marketing campaigns."
                },
                "automation": {
                    "title": "Automation",
                    "description": "Create and manage automated marketing scenarios."
                },
                "affiliateReports": {
                    "title": "Affiliate Reports",
                    "description": "View affiliate performance reports."
                }
            },
            "discount": {
                "title": "Discounts",
                "description": "Manage discount and campaign management operations.",
                "campaigns": {
                    "title": "Campaigns",
                    "description": "Create and manage campaigns."
                },
                "couponCodes": {
                    "title": "Coupon Codes",
                    "description": "Create and manage discount coupons."
                },
                "campaignOffers": {
                    "title": "Campaign Offers",
                    "description": "Create and manage special campaign offers."
                }
            },
            "app": {
                "title": "Applications",
                "description": "Manage system applications and integrations.",
                "market": {
                    "title": "App Market",
                    "description": "Discover and install new applications."
                },
                "myApps": {
                    "title": "My Apps",
                    "description": "View and manage installed applications."
                }
            }
        },
        "site": {
            "title": "Site Management",
            "description": "Manage site content, administrators and site settings.",
            "administrators": {
                "title": "Administrators",
                "description": "Manage administrator accounts and permissions.",
                "admins": {
                    "title": "Administrators",
                    "description": "Create and manage administrator accounts."
                },
                "groups": {
                    "title": "Administrator Groups",
                    "description": "Manage administrator groups and their permissions."
                }
            },
            "content": {
                "title": "Content Management",
                "description": "Create and manage site content modules.",
                "themes": {
                    "title": "My Themes",
                    "description": "Manage and customize site themes."
                },
                "media": {
                    "title": "Media Library",
                    "description": "Upload, organize and manage files."
                },
                "slider": {
                    "title": "Slider",
                    "description": "Manage home page slider content."
                },
                "featured_products": {
                    "title": "Featured Products",
                    "description": "Manage featured product groups and lists."
                },
                "blog": {
                    "title": "Blog",
                    "description": "Manage blog posts and categories.",
                    "posts": {
                        "title": "Posts",
                        "description": "Create and manage blog posts."
                    },
                    "categories": {
                        "title": "Categories",
                        "description": "Create and manage blog categories."
                    }
                },
                "pages": {
                    "title": "Pages",
                    "description": "Create and manage static site pages (About, privacy, terms, etc.)."
                },
                "faq": {
                    "title": "Frequently Asked Questions",
                    "description": "Create and manage frequently asked questions."
                },
                "forms": {
                    "title": "Form",
                    "description": "Manage forms and form responses."
                },
                "popup": {
                    "title": "Popup",
                    "description": "Create and manage site popup windows."
                },
                "links": {
                    "title": "Link Management",
                    "description": "Create and manage menus and links."
                },
                "menus": {
                    "title": "Menus",
                    "description": "Manage header/footer menus and their items (link, dropdown, mega)."
                }
            },
            "localization": {
                "title": "Localization",
                "description": "Manage language, currency and regional settings.",
                "languages": {
                    "title": "Languages",
                    "description": "Manage site languages."
                },
                "currencies": {
                    "title": "Currencies",
                    "description": "Manage currencies and their rates."
                },
                "taxes": {
                    "title": "Taxes",
                    "description": "Manage tax definitions."
                },
                "countries": {
                    "title": "Countries",
                    "description": "View countries, states and districts."
                }
            },
            "settings": {
                "title": "Settings",
                "description": "Configure site and system settings.",
                "general": {
                    "title": "General Settings",
                    "description": "Configure site, registration and system variable settings."
                },
                "register": {
                    "title": "Sign-up Settings",
                    "description": "Configure settings related to member registration (sign up)."
                },
                "site": {
                    "title": "Site Settings",
                    "description": "Configure general site settings.",
                    "homepage": {
                        "title": "Home Page Settings",
                        "description": "Configure settings related to the home page."
                    }
                },
                "theme": {
                    "title": "Theme Settings",
                    "description": "Manage the active theme's colors."
                },
                "system_variables": {
                    "title": "System Variables",
                    "description": "Manage system-wide variables."
                },
                "system": {
                    "title": "System Settings",
                    "description": "Configure advanced system settings.",
                    "register": {
                        "title": "Sign Up Settings",
                        "description": "Configure settings related to member registration (sign up)."
                    }
                },
                "tracking_codes": {
                    "title": "Tracking Codes",
                    "description": "Manage analytics and tracking codes."
                },
                "media_providers": {
                    "title": "Media Providers",
                    "description": "Manage video/streaming providers and accounts."
                }
            }
        }
    },
    "messages": {
        "warning": "Warning",
        "success": "Success",
        "error": "Error",
        "sureAction": "Are you sure you want to perform this action? Please be careful.",
        "sureConfirm": "Are you sure you want to confirm this action?",
        "sureDelete": "Are you sure you want to delete this record? This action cannot be undone.",
        "actionOk": "Your operation was completed successfully.",
        "copied": "copied",
        "deleteOk": "The deletion was completed successfully.",
        "copyOk": "The record was copied successfully. You can start using the new record.",
        "copyLinkOk": "Link copied successfully.",
        "copyLinkError": "An error occurred while copying the link.",
        "selectRow": "Please select a record to perform an action.",
        "wait": "Please wait",
        "loading": "Data is loading. Please be patient.",
        "noResultFound": "No results matching your search criteria were found. Please try again using different criteria.",
        "errorOccurred": "An error occurred",
        "exportFailed": "Export failed",
        "fillRequired": "Please fill in the required fields"
    },
    "btn": {
        "preview": "Preview",
        "new": "New",
        "add": "Add",
        "create": "Create",
        "copy": "Copy",
        "edit": "Edit",
        "detail": "Detail",
        "customerDelete": "Delete Customer",
        "delete": "Delete",
        "yes": "Yes",
        "no": "No",
        "cancel": "Cancel",
        "close": "Close",
        "refresh": "Refresh",
        "categories": "Categories",
        "export": "Export",
        "update": "Update",
        "filter": "Filter",
        "ship": "Ship",
        "save": "Save",
        "saveAll": "Save All",
        "select": "Select",
        "selectFile": "Select File",
        "upload": "Upload",
        "download": "Download",
        "action": "Action",
        "previous": "Previous",
        "ensuing": "Next",
        "next": "Next",
        "back": "Back",
        "send": "Send",
        "ok": "OK",
        "clear": "Clear",
        "tryAgain": "Try Again",
        "apply": "Apply",
        "reset": "Reset",
        "change": "Change",
        "check": "Check",
        "clone": "Clone",
        "selectedRowEvent": "Selected Record Actions"
    },
    "validation": {
        "required": "You must fill in this field.",
        "email": "Please enter a valid email address.",
        "number": "Only numeric values may be entered in this field.",
        "confirmed": "The information you entered does not match the confirmation. Please check.",
        "length": "This field must contain at least 2 options.",
        "password": "Please enter a strong and valid password.",
        "passwordConfirmation": "Please re-enter your password.",
        "dontMatchPassword": "The passwords you entered do not match. Please try again."
    },
    "pages": {
        "login": {
            "title": "Sign In",
            "description": "Sign in to your account to continue",
            "back": {
                "title": "Not a member yet?",
                "buttonTitle": "Sign Up"
            },
            "cols": {
                "customerID": "Customer Number",
                "email": "Email",
                "password": "Password",
                "confirmation": "I agree to the &amp; <a href='#' class='kt-link'>Terms and conditions</a>."
            },
            "successLogin": "You have signed in successfully. Welcome!",
            "btnText": "Sign In",
            "responseMessage": {
                "title": "An Error Occurred",
                "invalid_credentials": "Email or Password is incorrect. Please try again with valid credentials."
            },
            "placeholders": {
                "email": "you{'@'}example.com",
                "password": "••••••••",
                "customerID": "e.g. 100234"
            }
        },
        "auth": {
            "banner": {
                "title": "One panel, full control",
                "content": "Manage products, orders, customers and marketing in one place; grow your business confidently with real-time data.",
                "theme": {
                    "light": "Light Mode",
                    "dark": "Dark Mode",
                    "system": "Automatic"
                }
            },
            "register": {
                "title": "Create Account",
                "description": "Get unlimited access and earn money",
                "login": {
                    "title": "Already have an account?",
                    "signIn": "Sign In"
                },
                "cols": {
                    "firstname": "First Name",
                    "lastname": "Last Name",
                    "identificationNumber": "ID Number",
                    "email": "Email",
                    "mobilePhone": "Phone",
                    "birthDate": "Date of Birth",
                    "password": "Password",
                    "passwordConfirmation": "Confirm Password",
                    "confirmation": "I agree to the &amp; <a href='#' class='kt-link'>Terms and conditions</a>."
                },
                "sureRegister": {
                    "title": "Do you want to complete the registration?",
                    "description": "After registering, you cannot change your <b>email</b> and <b>phone number</b>, so make sure you have entered the correct information."
                },
                "responseMessage": {
                    "success": "You have completed your registration successfully! Welcome!"
                },
                "verify": {
                    "title": "Verify your email address",
                    "description": "Didn't receive the email? <a href='/auth/sign-up' class='kt-link kt-link-underlined kt-link-dashed'>Try Again</a>",
                    "buttonTitle": "Skip for now"
                }
            },
            "passwordReset": {
                "title": "Forgot your password?",
                "description": "Enter your email address to reset your password.",
                "back": {
                    "title": "Already a member?",
                    "buttonTitle": "Sign In"
                },
                "cols": {
                    "customerID": "Customer Number",
                    "email": "Email",
                    "confirmation": "I agree to the &amp; <a href='#' class='kt-link'>Terms and conditions</a>."
                },
                "responseMessage": {
                    "success": "Password reset instructions have been sent to your email address.",
                    "password_reset_rate_error": "You can make your password reset request 120 seconds after your last request."
                },
                "verify": {
                    "title": "Reset Password",
                    "description": "Enter your new password along with the confirmation code.",
                    "back": {
                        "title": "Already a member?",
                        "buttonTitle": "Sign In"
                    },
                    "cols": {
                        "email": "Email",
                        "password": "Password",
                        "passwordConfirmation": "Confirm Password",
                        "code": "Confirmation Code"
                    },
                    "responseMessage": {
                        "success": "Your password has been reset successfully.",
                        "invalid_token": "This link has expired or has already been used. Please request a new link."
                    }
                },
                "confirmation": {
                    "title": "Your password has been reset successfully.",
                    "description": "A great opportunity to be creative <a href='#' class='kt-link kt-link-underlined kt-link-dashed'>max{'@'}keenthemes.com</a> <br>gives readers an idea"
                }
            },
            "twoFactor": {
                "title": "Two-Factor Authentication",
                "description": "Enter the verification code we sent you",
                "phoneFormat": "******7859",
                "cols": {
                    "code": "Enter the 6-digit security code"
                }
            },
            "deActive": {
                "title": "Your account has been deactivated",
                "description": "You can take advantage of great opportunities. Please contact us for more information.",
                "btnText": "Back to Home"
            }
        },
        "account": {
            "overview": {
                "title": "Profile Details",
                "cols": {
                    "name": "First Name",
                    "surname": "Last Name",
                    "email": "Email",
                    "phone": "Phone",
                    "role": "Role"
                }
            },
            "settings": {
                "signInMethod": {
                    "title": "Sign-In Method",
                    "emailAddress": "Email Address",
                    "password": {
                        "title": "Password",
                        "cols": {
                            "currentPassword": "Current Password",
                            "password": "New Password",
                            "passwordConfirmation": "Confirm New Password"
                        },
                        "changePassword": "Change Password",
                        "updatePassword": "Update Password"
                    }
                }
            },
            "title": "My Account",
            "description": "View your account details and update your password."
        },
        "dashboard": {
            "cols": {
                "title": "Title"
            },
            "greet": "Welcome",
            "title": "Dashboard",
            "todayRevenue": "Today's Revenue",
            "ordersToday": "{n} orders today",
            "newOrder": "Order",
            "reports": "Reports",
            "salesTrend": "Sales Trend",
            "trendSub": "Daily revenue of the last 30 days",
            "trend30Total": "30-day total",
            "orderStatus": "Order Status",
            "noOrders": "No orders",
            "noOrdersYet": "No orders yet.",
            "noOrdersReceived": "No orders received yet.",
            "recentOrders": "Recent Orders",
            "all": "All",
            "guest": "Guest",
            "topProducts": "Top Selling Products",
            "report": "Report",
            "unit": "pcs",
            "noSales": "No sales",
            "noSalesYet": "No product sales yet.",
            "revenue": "Revenue",
            "total": "Total",
            "ordersSuffix": "orders",
            "loadError": "Could not load data.",
            "kpi": {
                "monthRevenue": "Revenue This Month",
                "monthOrders": "Orders This Month",
                "avgOrder": "Average Order",
                "customers": "Customers",
                "perOrder": "per order",
                "ordered": "who ordered"
            },
            "quick": {
                "products": "Products",
                "productsDesc": "Catalog management",
                "orders": "Orders",
                "ordersDesc": "Order management",
                "customers": "Customers",
                "customersDesc": "Customer management",
                "carts": "Abandoned Carts",
                "cartsDesc": "Recovery opportunities",
                "campaigns": "Campaigns",
                "campaignsDesc": "Discounts & promos",
                "apps": "Apps",
                "appsDesc": "Integrations"
            }
        },
        "ecommerce": {
            "marketing": {
                "emailSms": {
                    "newTitle": "New Campaign",
                    "editTitle": "Edit Campaign",
                    "channel": "Channel",
                    "channels": {
                        "email": "Email",
                        "sms": "SMS",
                        "push": "Push"
                    },
                    "campaignName": "Campaign Name",
                    "namePh": "e.g. Year-end sale announcement",
                    "audience": "Audience",
                    "customers": "customers",
                    "matchLabel": "Match",
                    "matchAll": "All rules",
                    "matchAny": "Any rule",
                    "allNote": "With no rules, it is sent to ALL customers with contact info for this channel.",
                    "searchProduct": "Search product...",
                    "selectTag": "Select tag",
                    "selectGroup": "Select group",
                    "addRule": "Add Rule",
                    "content": "Content",
                    "subject": "Email Subject",
                    "subjectPh": "{customer.name}, just for you!",
                    "smsPh": "Short message text. You can use {customer.name}.",
                    "chars": "chars",
                    "pushTitle": "Notification Title",
                    "pushTitlePh": "e.g. New Campaign!",
                    "message": "Message",
                    "pushMsgPh": "Push notification text",
                    "pushHint": "Push is broadcast to ALL subscribed users via OneSignal (requires a provider); audience count is informational.",
                    "saveDraft": "Save Draft",
                    "send": "Send",
                    "queued": "Campaign queued for sending.",
                    "nameRequired": "Campaign name is required.",
                    "emailRequired": "Please design the email content first.",
                    "messageRequired": "Message text is required.",
                    "reach": "Reach",
                    "sentShort": "sent",
                    "failedShort": "failed",
                    "date": "Date",
                    "confirmSend": "This campaign will be sent to ≈ {n} customers. Confirm?",
                    "status": {
                        "draft": "Draft",
                        "scheduled": "Scheduled",
                        "sending": "Sending",
                        "sent": "Sent",
                        "failed": "Failed"
                    }
                },
                "automation": {
                    "addTitle": "Create Automation",
                    "editTitle": "Edit Automation",
                    "builderHint": "Build the flow by dragging and connecting triggers, conditions and actions.",
                    "namePh": "e.g. Post-order thank-you email",
                    "description": "Description",
                    "descPh": "What does this automation do?",
                    "palette": "Components",
                    "settings": "Settings",
                    "selectNode": "Select a node to edit its settings.",
                    "noTrigger": "No trigger",
                    "namePh2": "Automation name",
                    "nameRequired": "Automation name is required.",
                    "triggerRequired": "You must add at least one trigger.",
                    "oneTrigger": "A flow can have only one trigger.",
                    "removeNode": "Delete Node",
                    "matchMode": "Match",
                    "matchAll": "All (AND)",
                    "matchAny": "Any (OR)",
                    "needTrigger": "Add a trigger first to use condition fields.",
                    "condition": "Condition",
                    "addCondition": "Add Condition",
                    "field": "Field",
                    "value": "Value",
                    "selectTag": "Select tag",
                    "selectGroup": "Select group",
                    "variables": "Available variables (click to copy)",
                    "groups": {
                        "trigger": "Trigger",
                        "condition": "Condition",
                        "ab_test": "A/B Test",
                        "delay": "Delay",
                        "action": "Action"
                    },
                    "canvas": {
                        "empty": "Drag a trigger from the palette on the left to start.",
                        "yes": "Yes",
                        "no": "No",
                        "conditionWord": "conditions",
                        "noCondition": "No condition set",
                        "splitWord": "split",
                        "waitWord": "wait",
                        "noDuration": "No duration set",
                        "notSet": "Not set",
                        "zoomIn": "Zoom in",
                        "zoomOut": "Zoom out",
                        "fit": "Fit",
                        "units": {
                            "minute": "minute",
                            "hour": "hour",
                            "day": "day",
                            "week": "week",
                            "month": "month"
                        }
                    },
                    "trig": {
                        "order_created": "Order Created",
                        "order_status_changed": "Order Status Changed",
                        "order_paid": "Order Paid",
                        "order_cancelled": "Order Cancelled",
                        "customer_registered": "New Customer Registered",
                        "cart_abandoned": "Cart Abandoned"
                    },
                    "cols": {
                        "name": "Automation",
                        "trigger": "Trigger",
                        "runs": "Runs",
                        "updated": "Updated"
                    },
                    "email": {
                        "title": "Email Design",
                        "contentLabel": "Email Content",
                        "notDesigned": "Email not designed yet",
                        "design": "Design Email",
                        "edit": "Edit Email",
                        "templates": "Templates",
                        "tplConfirm": "Your current design will be replaced by the selected template. Continue?",
                        "heroTitle": "Title",
                        "heroSubtitle": "Subtitle",
                        "titleColor": "Title Color",
                        "subtitleColor": "Subtitle Color",
                        "padding": "Padding (px)",
                        "icon": "Icon",
                        "iconColor": "Icon Color",
                        "itemsHeading": "Section Title",
                        "itemsHeadingPh": "e.g. Order Summary",
                        "itemsNote": "Real products are added at send time",
                        "itemsInfo": "This block is auto-filled at send time with the real products (image, quantity, amount) from the order / cart.",
                        "tpl": {
                            "welcome": "Welcome",
                            "order": "Order Confirmation",
                            "promo": "Promo",
                            "cart": "Cart Reminder"
                        },
                        "block": {
                            "hero": "Hero Banner",
                            "logo": "Logo",
                            "heading": "Heading",
                            "text": "Text",
                            "icon": "Icon",
                            "features": "Icon List",
                            "items": "Products",
                            "button": "Button",
                            "image": "Image",
                            "social": "Social",
                            "divider": "Divider",
                            "spacer": "Spacer",
                            "footer": "Footer"
                        },
                        "featTitle": "Title",
                        "featDesc": "Description",
                        "blocks": "Blocks",
                        "global": "Global Settings",
                        "bg": "Background",
                        "cardBg": "Content Color",
                        "textColor": "Text Color",
                        "width": "Width (px)",
                        "radius": "Corner Radius",
                        "content": "Content",
                        "logoText": "Logo Text",
                        "image": "Image URL",
                        "logoHint": "Pick a logo image or enter a URL (text shown if empty).",
                        "widthPx": "Width (px)",
                        "btnText": "Button Text",
                        "btnUrl": "Button Link",
                        "btnBg": "Button Color",
                        "btnColor": "Text Color",
                        "link": "Link (URL)",
                        "widthPct": "Width (%)",
                        "color": "Color",
                        "height": "Height (px)",
                        "align": "Alignment",
                        "size": "Size",
                        "removeBlock": "Delete Block",
                        "selectBlock": "Select a block to edit.",
                        "emptyHint": "Add blocks from the left panel to build your email.",
                        "dragMove": "Move",
                        "duplicate": "Duplicate",
                        "sampleProduct": "Sample Product",
                        "qtyLabel": "Qty"
                    }
                },
                "summaryPage": {
                    "eyebrow": "Marketing",
                    "title": "Marketing Hub",
                    "subtitle": "Track your campaigns, automations and customer interest from a single screen.",
                    "newCampaign": "New Campaign",
                    "newAutomation": "New Automation",
                    "viewAll": "View all",
                    "loadError": "Could not load summary data.",
                    "kpi": {
                        "campaigns": "Campaigns",
                        "sent": "sent",
                        "recipients": "Recipients Reached",
                        "delivered": "delivered",
                        "automations": "Active Automations",
                        "totalShort": "total",
                        "runs": "Automation Runs",
                        "runsSub": "total triggers",
                        "favorites": "Favorites",
                        "customers": "customers"
                    },
                    "channels": {
                        "title": "Channel Breakdown",
                        "subtitle": "Campaign count by channel",
                        "email": "Email",
                        "sms": "SMS",
                        "push": "Push Notification",
                        "noData": "No campaigns yet"
                    },
                    "campaigns": {
                        "title": "Recent Campaigns",
                        "recipients": "recipients",
                        "empty": "No campaigns yet",
                        "emptyHint": "Create your first bulk email/SMS campaign."
                    },
                    "automations": {
                        "title": "Most Active Automations",
                        "runs": "runs",
                        "active": "Active",
                        "passive": "Passive",
                        "empty": "No automations yet",
                        "emptyHint": "Set up your first trigger-based automation."
                    },
                    "favorites": {
                        "title": "Most Favorited Products",
                        "times": "times",
                        "empty": "No favorites yet",
                        "emptyHint": "Appears here when customers favorite products."
                    },
                    "status": {
                        "draft": "Draft",
                        "scheduled": "Scheduled",
                        "sending": "Sending",
                        "sent": "Sent",
                        "failed": "Failed"
                    }
                }
            },
            "report": {
                "refresh": "Refresh",
                "refreshed": "Report updated",
                "loadError": "An error occurred while loading report data.",
                "empty": "No records found",
                "updatedNote": "Report data is cached for 24 hours for performance; press Refresh for the latest figures.",
                "searchProduct": "Search product (min. 2 chars)…",
                "searchCustomer": "Search customer (min. 2 chars)…",
                "prev": "Previous",
                "next": "Next",
                "goToday": "Back to today",
                "pickProduct": "Select a product",
                "pickCustomer": "Select a customer",
                "pickProductHint": "Select a product from the search box above to view the report.",
                "pickCustomerHint": "Select a customer from the search box above to view the report.",
                "vsPrev": "vs previous period",
                "salesTrend": "Sales Trend",
                "revenueTrend": "Revenue Trend",
                "periodTotal": "Period total",
                "orderStatus": "Order Status",
                "noOrdersPeriod": "No orders in this period",
                "customerSummary": "Customer Summary",
                "lifetimeOrders": "Lifetime orders",
                "lifetimeValue": "Lifetime value",
                "avgOrder": "Average order",
                "firstOrder": "First order",
                "lastOrder": "Last order",
                "topBought": "Most Purchased Products",
                "topSold": "Top Selling Products",
                "unit": "pcs",
                "note": "Figures exclude cancelled/returned/pending-payment orders. General counts cover all time.",
                "totalOrders": "Total Orders",
                "ordersSuffix": "orders",
                "period": {
                    "day": "Daily",
                    "week": "Weekly",
                    "month": "Monthly",
                    "year": "Yearly"
                },
                "mode": {
                    "general": "General",
                    "product": "Product",
                    "customer": "Customer"
                },
                "trend": {
                    "hourly": "Hourly {n}",
                    "daily": "Daily {n}",
                    "dailyRange": "Daily {n} (Mon–Sun)",
                    "monthly": "Monthly {n}"
                },
                "noun": {
                    "salesUnit": "sales (pcs)",
                    "spending": "spending",
                    "revenue": "revenue"
                },
                "kpi": {
                    "soldUnits": "Units Sold",
                    "revenue": "Revenue",
                    "orders": "Orders",
                    "containingThis": "containing this product",
                    "allTime": "All Time",
                    "periodOrders": "Period Orders",
                    "periodSpending": "Period Spending",
                    "lifetimeValue": "Lifetime Value",
                    "avgOrderShort": "Avg. Order",
                    "lifetime": "lifetime",
                    "periodRevenue": "Period Revenue",
                    "avgOrder": "Average Order",
                    "totalProducts": "Total Products",
                    "registeredProducts": "registered products (all time)",
                    "perOrder": "per order"
                }
            },
            "salesChannels": {
                "addTitle": "Add Channel",
                "editTitle": "Edit Channel",
                "cols": {
                    "name": "Name",
                    "code": "Code",
                    "sort": "Order"
                },
                "custom": "Custom",
                "systemChannelHint": "System channel — it cannot be deleted because checkout and integrations reference this code.",
                "namePlaceholder": "Instagram, Phone…",
                "warehouses": {
                    "action": "Warehouses",
                    "title": "Channel Warehouse Assignment",
                    "hint": "Determines which warehouse (by priority order) fulfills orders from this channel and the stock quantity reported to the channel.",
                    "empty": "No warehouses assigned to this channel yet — all warehouses are used.",
                    "warehouse": "Warehouse",
                    "priority": "Priority",
                    "stockRatio": "Stock Ratio (%)",
                    "safetyStock": "Safety Stock",
                    "add": "Add Warehouse"
                }
            },
            "stock": {
                "warehouse": {
                    "title": "Warehouses",
                    "empty": "No warehouses defined yet. Add your first warehouse.",
                    "addTitle": "Add Warehouse",
                    "editTitle": "Edit Warehouse",
                    "default": "Default",
                    "isDefault": "Default Warehouse",
                    "isDefaultHint": "There can be only one default warehouse in the system.",
                    "isSellable": "Sellable",
                    "isSellableHint": "If off, it is not used for sales (e.g. returns warehouse).",
                    "cols": {
                        "name": "Name",
                        "code": "Code",
                        "type": "Type",
                        "city": "City",
                        "address": "Address",
                        "priority": "Priority",
                        "sellable": "Sellable"
                    },
                    "types": {
                        "warehouse": "Warehouse",
                        "store": "Store",
                        "virtual": "Virtual"
                    }
                },
                "status": {
                    "title": "Stock Status",
                    "viewMovements": "View Movements",
                    "searchPlaceholder": "Search products…",
                    "stockCode": "Stock Code",
                    "stockState": "Stock Status",
                    "states": {
                        "in_stock": "In Stock",
                        "out_of_stock": "Out of Stock",
                        "critical": "Critical"
                    },
                    "criticalOnly": "Critical only",
                    "criticalHint": "Available stock is at or below the minimum threshold.",
                    "editLevels": "Edit Thresholds",
                    "maxLevel": "Maximum Threshold",
                    "shelf": "Shelf Location",
                    "adjust": "Adjust Stock",
                    "adjustTitle": "Manual Stock Adjustment",
                    "current": "Current",
                    "targetQuantity": "Target Quantity",
                    "note": "Note",
                    "notePlaceholder": "Reason for adjustment (required)",
                    "cols": {
                        "warehouse": "Warehouse",
                        "product": "Product",
                        "quantity": "Quantity",
                        "reserved": "Reserved",
                        "incoming": "Incoming",
                        "available": "Available",
                        "min": "Min. Threshold"
                    }
                },
                "movement": {
                    "title": "Stock Movements",
                    "dateRange": "Date Range",
                    "cols": {
                        "date": "Date",
                        "warehouse": "Warehouse",
                        "product": "Product",
                        "type": "Type",
                        "quantity": "Quantity",
                        "after": "After",
                        "reference": "Reference",
                        "note": "Note"
                    },
                    "types": {
                        "initial": "Opening",
                        "purchase_in": "Purchase In",
                        "sale_out": "Sale Out",
                        "transfer_in": "Transfer In",
                        "transfer_out": "Transfer Out",
                        "adjustment_in": "Adjustment In",
                        "adjustment_out": "Adjustment Out",
                        "return_in": "Return In",
                        "count_correction": "Count Correction"
                    }
                },
                "purchase": {
                    "title": "Purchases",
                    "empty": "No purchase orders yet. Create a new draft.",
                    "itemsShort": "Item",
                    "addTitle": "New Purchase",
                    "expectedDate": "Expected Date",
                    "createdAt": "Created Date",
                    "total": "Amount",
                    "currency": "Currency",
                    "exchangeRate": "Rate",
                    "items": "Items",
                    "addItem": "Add Item",
                    "noItems": "No items added yet.",
                    "selectProduct": "Select a product…",
                    "variant": "Variant",
                    "variants": "Variants",
                    "selectVariant": "Select a variant…",
                    "variantRequired": "You must select a combination for products with variants.",
                    "bulkApplyHint": "apply to all:",
                    "applyAll": "Apply to all",
                    "unitPrice": "Unit Price",
                    "taxRate": "Tax %",
                    "received": "Received",
                    "receiveNow": "Receive Now",
                    "receiveAll": "Receive All",
                    "fillRemaining": "Fill remaining ({n})",
                    "doReceive": "Receive Goods",
                    "createDraft": "Create Draft",
                    "cols": {
                        "code": "Code",
                        "warehouse": "Warehouse",
                        "supplier": "Supplier",
                        "product": "Product",
                        "quantity": "Quantity"
                    },
                    "statuses": {
                        "draft": "Draft",
                        "ordered": "Ordered",
                        "partially_received": "Partially Received",
                        "received": "Received",
                        "cancelled": "Cancelled"
                    }
                },
                "transfer": {
                    "title": "Transfers",
                    "empty": "No transfers yet. Create a new draft.",
                    "itemsShort": "Item",
                    "addTitle": "New Transfer",
                    "createdAt": "Created At",
                    "route": "Route",
                    "fromWarehouse": "Source Warehouse",
                    "toWarehouse": "Destination Warehouse",
                    "items": "Items",
                    "addItem": "Add Item",
                    "noItems": "No items added yet.",
                    "selectProduct": "Select product…",
                    "variant": "Variant",
                    "selectVariant": "Select a variant…",
                    "variantRequired": "You must select a combination for products with variants.",
                    "createDraft": "Create Draft",
                    "cols": {
                        "code": "Code",
                        "product": "Product",
                        "quantity": "Quantity"
                    },
                    "statuses": {
                        "draft": "Draft",
                        "in_transit": "In Transit",
                        "completed": "Completed",
                        "cancelled": "Cancelled"
                    }
                },
                "count": {
                    "title": "Stock Counts",
                    "empty": "No stock counts yet. Create a new count.",
                    "addTitle": "New Count",
                    "createdAt": "Created At",
                    "completedAt": "Completed At",
                    "note": "Note",
                    "notePlaceholder": "e.g. Year-end count",
                    "startHint": "When you start the count, current balances are captured as the expected quantities.",
                    "categories": "Categories (scope)",
                    "categoriesHint": "If left empty, the entire warehouse is included in the count.",
                    "allWarehouse": "All warehouses",
                    "start": "Start Count",
                    "saveCounts": "Save Count",
                    "complete": "Complete",
                    "completeConfirm": "The count will be completed and a stock adjustment will be made for the differences. Continue?",
                    "expected": "Expected",
                    "counted": "Counted",
                    "fillAll": "Fill with Expected",
                    "fillExpected": "Fill with expected ({n})",
                    "diff": "Difference",
                    "noLines": "No count lines found.",
                    "cols": {
                        "code": "Code",
                        "warehouse": "Warehouse",
                        "note": "Note",
                        "product": "Product"
                    },
                    "statuses": {
                        "draft": "Draft",
                        "in_progress": "In Progress",
                        "completed": "Completed",
                        "cancelled": "Cancelled"
                    }
                }
            },
            "tags": {
                "addTitle": "New Tag",
                "editTitle": "Edit Tag",
                "nameLabel": "Tag Name",
                "namePlaceholder": "Tag name",
                "visibilityLabel": "Visibility",
                "visible": "Visible",
                "hidden": "Hidden",
                "sortLabel": "Sort Order",
                "cols": {
                    "tag": "Tag",
                    "visibility": "Visibility",
                    "sort": "Sort Order",
                    "usage": "Usage",
                    "productCount": "Product Count",
                    "orderCount": "Order Count",
                    "customerCount": "Customer Count"
                },
                "createOk": "Tag added",
                "updateOk": "Tag updated"
            },
            "order": {
                "giftCards": {
                    "addTitle": "Create Gift Card",
                    "editTitle": "Edit Gift Card",
                    "cardInfo": "Gift Card Details",
                    "codeLabel": "Gift Card Code",
                    "codePlaceholder": "e.g. NEWYEAR2026 (max. 20)",
                    "generate": "Generate Code",
                    "currency": "Currency",
                    "value": "Gift Card Value",
                    "currentBalance": "Current Balance",
                    "usedAmount": "Used",
                    "requirements": "Requirements",
                    "minAmount": "Minimum Order Amount",
                    "minAmountHint": "Minimum cart total required for the card to be valid (no limit if empty).",
                    "noMinAmount": "No limit",
                    "startDate": "Start Date",
                    "endDate": "End Date",
                    "datePlaceholder": "Select a date",
                    "customer": "Customer",
                    "searchCustomer": "Search by customer name…",
                    "customerHint": "If left empty, the gift card can be used by anyone.",
                    "anyCustomer": "Everyone",
                    "salesChannel": "Sales Channel",
                    "allChannels": "All channels",
                    "salesChannelHint": "The sales channel where the card is valid (if empty, valid on all channels).",
                    "balanceOps": "Balance & Transaction History",
                    "adjustBalance": "Adjust Balance",
                    "adjustPlaceholder": "e.g. -100 or 250",
                    "adjustNote": "Note (optional)",
                    "adjustHint": "A positive amount adds to the balance, a negative amount deducts. The balance cannot go below 0.",
                    "apply": "Apply",
                    "adjustOk": "Balance updated",
                    "errBalanceNegative": "Balance cannot go below 0.",
                    "history": "Transaction History",
                    "noHistory": "No transactions yet.",
                    "createOk": "Gift card created",
                    "updateOk": "Gift card updated",
                    "states": {
                        "active": "Active",
                        "passive": "Inactive",
                        "depleted": "Depleted",
                        "expired": "Expired",
                        "scheduled": "Scheduled",
                        "usable": "Usable"
                    },
                    "tx": {
                        "issue": "Opening",
                        "redeem": "Redemption",
                        "refund": "Refund",
                        "adjust": "Adjustment"
                    },
                    "cols": {
                        "code": "Code",
                        "balance": "Balance",
                        "customer": "Customer",
                        "dates": "Validity"
                    }
                },
                "cartLinks": {
                    "addTitle": "Create Cart Link",
                    "editTitle": "Edit Cart Link",
                    "general": "General",
                    "cols": {
                        "title": "Title",
                        "items": "Products",
                        "coupon": "Coupon",
                        "stats": "Stats",
                        "expires": "Expires"
                    },
                    "code": "Code",
                    "product": "product",
                    "viewCount": "Views",
                    "orderCount": "Orders",
                    "copyUrl": "Copy link",
                    "urlCopied": "Link copied to clipboard.",
                    "titlePlaceholder": "John's WhatsApp",
                    "titleHint": "Note visible only in the panel; not shown to the customer.",
                    "noExpiry": "No expiry",
                    "itemsTitle": "Products",
                    "addProduct": "Add Product",
                    "noItems": "Add at least one product to the link.",
                    "selectProduct": "Select a product",
                    "searchProduct": "Search by product name…",
                    "selectVariant": "Select variant",
                    "noVariant": "No variant",
                    "personalizations": "Personalizations",
                    "fillRequiredPers": "Fill in the required personalization fields.",
                    "requiredFileBlock": "This product has a required file-type personalization — since files cannot be uploaded from the panel, the product cannot be added to the link. You can make the field optional from the product screen.",
                    "fileNotSupported": "The file field cannot be filled from the panel; it is left empty.",
                    "itemError": "Error on item {row}: {error}",
                    "errors": {
                        "requiredVariant": "You must select a variant for product {row}.",
                        "invalidVariant": "The variant selected for product {row} is invalid.",
                        "invalidProduct": "Product on row {row} is not on sale (inactive or outside its sale dates).",
                        "invalidQuantity": "Invalid quantity for product {row}.",
                        "personalizationRequired": "Required personalization field ({name}) is empty on item {row}.",
                        "invalidPersValue": "Product {row} has an invalid personalization value (a choice not in the list or an invalid date).",
                        "unsupportedPers": "A personalization field not belonging to the product was submitted for product {row}.",
                        "persValueTooLong": "Personalization text for the product on row {row} exceeds the character limit.",
                        "persDependencyNotMet": "In product {row}, a dependent field is filled while the field it depends on is empty."
                    }
                },
                "list": {
                    "cols": {
                        "order": "Order",
                        "customer": "Customer",
                        "items": "Items",
                        "total": "Total",
                        "payment": "Payment",
                        "status": "Status",
                        "date": "Date"
                    },
                    "vat": "VAT",
                    "installment": "installment",
                    "shipConfirm": "{count} orders will be shipped. Do you confirm?",
                    "shipOk": "Orders have been shipped"
                },
                "statuses": {
                    "system": "System",
                    "custom": "Custom",
                    "addTitle": "New Status",
                    "editTitle": "Edit Status",
                    "codeLabel": "Code",
                    "nameLabel": "Name",
                    "namePlaceholder": "Status name",
                    "cols": {
                        "code": "Code",
                        "name": "Name",
                        "type": "Type"
                    },
                    "updateOk": "Status updated",
                    "createOk": "Status added"
                },
                "create": {
                    "title": "New Order",
                    "subtitle": "Create a new order manually.",
                    "createOrder": "Create Order",
                    "products": "Products",
                    "addProduct": "Add Product",
                    "product": "Product",
                    "searchProduct": "Search product…",
                    "variant": "Variant",
                    "selectVariant": "Select a variant combination",
                    "variantRequired": "Variant selection is required for products with variants",
                    "quantity": "Quantity",
                    "usageStart": "Usage Start",
                    "usageEnd": "Usage End",
                    "optional": "Optional",
                    "loadingExtras": "Loading addons and package items…",
                    "addons": "Addons",
                    "packageItems": "Package Items",
                    "customUsageStart": "Custom usage start",
                    "customUsageEnd": "Custom usage end",
                    "customer": "Customer",
                    "searchCustomer": "Search customer…",
                    "address": "Address",
                    "selectAddress": "Select an address",
                    "selectCustomerFirst": "Select a customer first",
                    "noCustomerAddress": "This customer has no saved address.",
                    "orderStatus": "Order Status",
                    "productDetailFail": "Product details could not be retrieved",
                    "addressFetchFail": "Addresses could not be retrieved",
                    "addAtLeastOneProduct": "Add at least one product",
                    "createOk": "Order created"
                },
                "detail": {
                    "title": "Order Detail",
                    "subtitle": "View order information.",
                    "orderNo": "Order #{id}",
                    "products": "Products",
                    "cols": {
                        "product": "Product",
                        "quantity": "Quantity",
                        "subtotal": "Subtotal",
                        "total": "Total"
                    },
                    "variantNo": "Variant #{id}",
                    "noProducts": "No products",
                    "summary": "Summary",
                    "vat": "VAT",
                    "shipping": "Shipping",
                    "usageDates": "Usage Dates",
                    "notes": "Notes",
                    "notePlaceholder": "Add an order note…",
                    "addNote": "Add Note",
                    "noNotes": "No notes added yet",
                    "customer": "Customer",
                    "deliveryAddress": "Delivery Address",
                    "payment": "Payment",
                    "method": "Method",
                    "subMethod": "Sub-Method",
                    "installmentLabel": "Installment",
                    "paid": "Paid",
                    "remainingCollection": "Remaining Collection",
                    "addCollection": "Add Collection",
                    "amount": "Amount",
                    "collectAllShort": "All",
                    "collectAllTooltip": "Collect All (fills in the remaining amount)",
                    "noteOptional": "Note (optional)",
                    "weight": "Weight",
                    "trackingNumber": "Tracking Number",
                    "waybill": "Waybill",
                    "movements": "Movements",
                    "delivered": "Delivered",
                    "notDelivered": "Not delivered",
                    "noMovements": "No movement information available",
                    "orderInfo": "Order Information",
                    "notFound": "Order not found",
                    "updateStatus": "Update Status",
                    "updateStatusHint": "Select a new status for the order.",
                    "statusUpdateOk": "Order status updated",
                    "trackingSaveOk": "Shipping tracking number saved",
                    "enterNote": "Please enter a note",
                    "noteAddOk": "Note added",
                    "enterValidAmount": "Enter a valid amount",
                    "collectionAddOk": "Collection added",
                    "usageDatesUpdateOk": "Usage dates updated",
                    "shippingFetchFail": "Shipping information could not be retrieved",
                    "waybillFail": "Waybill preview could not be retrieved",
                    "deleteConfirm": "This order will be deleted. Do you confirm?"
                }
            },
            "customer": {
                "list": {
                    "cols": {
                        "customer": "Customer",
                        "contact": "Contact",
                        "labels": "Tags",
                        "status": "Status",
                        "date": "Registration Date"
                    },
                    "selfLogin": "Log In to Account",
                    "loginKeyReceived": "Login key received",
                    "loginStarted": "Login process started"
                },
                "tags": {
                    "addTitle": "New Tag",
                    "editTitle": "Edit Tag",
                    "nameLabel": "Tag Name",
                    "namePlaceholder": "Tag name",
                    "cols": {
                        "tag": "Tag",
                        "customerCount": "Customer Count"
                    },
                    "updateOk": "Tag updated",
                    "createOk": "Tag added"
                },
                "save": {
                    "addTitle": "New Customer",
                    "editTitle": "Edit Customer",
                    "subtitle": "Enter and save the customer information.",
                    "generalInformation": "General Information",
                    "firstname": "First Name",
                    "lastname": "Last Name",
                    "email": "Email",
                    "phone": "Phone",
                    "gender": "Gender",
                    "birthDate": "Date of Birth",
                    "selectDate": "Select a date",
                    "idNumber": "National ID No",
                    "idNumberPlaceholder": "11 digits",
                    "abroad": "Abroad",
                    "addresses": "Addresses",
                    "addAddress": "Add Address",
                    "default": "Default",
                    "noAddress": "No saved address",
                    "statusAndLabels": "Status & Tags",
                    "labels": "Tags",
                    "changePassword": "Change Password",
                    "password": "Password",
                    "newPassword": "New password",
                    "passwordConfirm": "Password (Confirm)",
                    "passwordConfirmPlaceholder": "Confirm password",
                    "newPasswordConfirm": "Confirm new password",
                    "updatePassword": "Update Password",
                    "notFound": "Customer not found, you have been redirected to the new record screen.",
                    "updateOk": "Customer updated",
                    "createOk": "Customer created",
                    "passwordMismatch": "Passwords must not be empty and must match",
                    "passwordUpdateOk": "Password updated",
                    "address": {
                        "addTitle": "New Address",
                        "editTitle": "Edit Address",
                        "title": "Address Title",
                        "titlePlaceholder": "Home, Work…",
                        "country": "Country",
                        "state": "State",
                        "city": "District",
                        "district": "Neighborhood/Quarter",
                        "districtPlaceholder": "Neighborhood",
                        "zipCode": "Postal Code",
                        "fullAddress": "Full Address",
                        "fullAddressPlaceholder": "Avenue, street, no…",
                        "invoiceType": "Invoice Type",
                        "companyName": "Company Name",
                        "taxOffice": "Tax Office",
                        "setDefault": "Set as default address",
                        "updateOk": "Address updated",
                        "createOk": "Address added"
                    }
                }
            },
            "product": {
                "list": {
                    "variantShort": "variants",
                    "variantStockHint": "Variant product — the shown stock is the sum of combination stocks.",
                    "cols": {
                        "product": "Product",
                        "group": "Group",
                        "type": "Type",
                        "price": "Price",
                        "stock": "Stock",
                        "status": "Status"
                    }
                },
                "collation": {
                    "category": {
                        "addTitle": "Add Category",
                        "editTitle": "Edit Category",
                        "generalInformation": "General Details",
                        "cols": {
                            "title": "Title",
                            "description": "Description",
                            "sort": "Order",
                            "status": "Status",
                            "icon": "Icon",
                            "image": "Image",
                            "type": "Type"
                        },
                        "general": "General",
                        "titlePlaceholder": "Category name",
                        "slugPlaceholder": "category-slug",
                        "descriptionPlaceholder": "Short description",
                        "settings": "Settings",
                        "typeLabel": "Category Type",
                        "typeSimple": "Classic",
                        "typeDynamic": "Dynamic",
                        "typeSimpleHint": "Products are assigned to the category manually.",
                        "typeDynamicHint": "Products are automatically matched based on the tags you select.",
                        "tagMatchMode": "Tag Match Mode",
                        "tagMatchAny": "Any (OR)",
                        "tagMatchAll": "All (AND)",
                        "tags": "Tags",
                        "tagsPlaceholder": "Select product tags",
                        "tagsEmpty": "No tags found",
                        "seoSettings": "SEO Settings",
                        "attributeSet": "Attribute Set",
                        "attributeSetPlaceholder": "Select a set (optional)",
                        "attributeSetHint": "Products in this category inherit the custom fields of the selected set.",
                        "seoCols": {
                            "slug": "Slug",
                            "title": "SEO Title",
                            "description": "SEO Description",
                            "keywords": "SEO Keywords"
                        }
                    },
                    "brand": {
                        "addTitle": "Add Brand",
                        "editTitle": "Edit Brand",
                        "general": "General",
                        "cols": {
                            "title": "Title",
                            "description": "Description",
                            "image": "Image",
                            "sort": "Order",
                            "products": "Products"
                        },
                        "titlePlaceholder": "Brand name",
                        "slugPlaceholder": "brand-slug",
                        "descriptionPlaceholder": "Short description"
                    },
                    "suppliers": {
                        "addTitle": "Add Supplier",
                        "editTitle": "Edit Supplier",
                        "general": "General",
                        "contact": "Contact",
                        "billing": "Billing Details",
                        "cols": {
                            "name": "Name",
                            "company": "Company",
                            "employeeName": "Contact",
                            "email": "Email",
                            "phone": "Phone",
                            "address": "Address",
                            "taxNumber": "Tax Number",
                            "taxOffice": "Tax Office",
                            "taxInfo": "Tax Info",
                            "contact": "Contact"
                        },
                        "namePlaceholder": "Supplier name",
                        "companyPlaceholder": "Company name",
                        "employeeNamePlaceholder": "Contact person name",
                        "addressPlaceholder": "Full address",
                        "taxOfficePlaceholder": "Tax office"
                    },
                    "product_units": {
                        "addTitle": "Add Unit",
                        "editTitle": "Edit Unit",
                        "cols": {
                            "code": "Code",
                            "name": "Name",
                            "sort": "Order"
                        },
                        "namePlaceholder": "kilogram",
                        "codeHint": "The code is unique and used in programmatic references; the name can be changed freely."
                    },
                    "attribute": {
                        "title": "Custom Fields",
                        "sets": "Attribute Sets",
                        "globalFields": "Global Fields",
                        "globalFieldsHint": "Common fields that apply to every set and are not tied to a specific set.",
                        "fieldsOf": "{name} — Fields",
                        "optionsOf": "{name} — Options",
                        "viewFields": "View Fields",
                        "viewOptions": "View Options",
                        "emptyFields": "No fields defined in this set yet.",
                        "emptyOptions": "No options defined for this field yet.",
                        "addSet": "Add Set",
                        "editSet": "Edit Set",
                        "addField": "Add Field",
                        "editField": "Edit Field",
                        "addOption": "Add Option",
                        "editOption": "Edit Option",
                        "codeHint": "Unique, programmatic key (a-z, 0-9, _ , -). Cannot be changed after creation.",
                        "typeLocked": "The type cannot be changed after creation.",
                        "behavior": "Behavior",
                        "validation": "Validation Rules",
                        "optionsAfterSave": "You can add options after saving the field.",
                        "colorHex": "Color Code",
                        "cols": {
                            "code": "Code",
                            "name": "Name",
                            "description": "Description",
                            "type": "Type",
                            "unit": "Unit",
                            "flags": "Attributes",
                            "value": "Value",
                            "label": "Label",
                            "sort": "Order",
                            "fieldCount": "Fields"
                        },
                        "flags": {
                            "required": "Required",
                            "filterable": "Filterable",
                            "searchable": "Searchable",
                            "comparable": "Comparable",
                            "variant": "Variant",
                            "visible": "Visible on Storefront"
                        },
                        "types": {
                            "text": "Text",
                            "textarea": "Long Text",
                            "richtext": "Rich Text",
                            "number": "Integer",
                            "decimal": "Decimal",
                            "boolean": "Yes / No",
                            "select": "Single Select",
                            "multiselect": "Multiselect",
                            "color": "Color",
                            "date": "Date",
                            "datetime": "Date & Time",
                            "url": "Link",
                            "range": "Range",
                            "json": "JSON"
                        }
                    },
                    "variant": {
                        "cols": {
                            "title": "Title",
                            "description": "Description",
                            "sort": "Order",
                            "status": "Status",
                            "icon": "Icon",
                            "name": "Name",
                            "itemCount": "Item Count",
                            "type": "Type"
                        },
                        "typeLabel": "Display Type",
                        "typeList": "List",
                        "typeColor": "Color / Image",
                        "typeListHint": "Items are shown as a plain text list (e.g. Size: S, M, L).",
                        "typeColorHint": "Each item carries a color or image swatch (e.g. Color: Black, Red).",
                        "valueLabel": "Value (color / image)",
                        "valuePlaceholder": "#000000 or /uploads/swatch.png",
                        "valueHint": "Enter a hex color code (#1E88E5) or an image path.",
                        "addTitle": "New Variant Group",
                        "editTitle": "Edit Variant Group",
                        "systemRecord": "System Record",
                        "systemRecordHint": "This record is managed by the system and cannot be edited.",
                        "systemRecordNotSortable": "System record cannot be sorted",
                        "codeLabel": "Code",
                        "nameLabel": "Name",
                        "namePlaceholder": "Variant group name",
                        "productGroups": "Product Groups",
                        "items": "Items",
                        "addItem": "Add Item",
                        "addItemTitle": "Add new item",
                        "saveGroupFirst": "Save the group first",
                        "reorderHint": "Drag and drop to reorder the items",
                        "dragToSort": "Drag to sort",
                        "noItems": "No items added yet",
                        "noItemsHint": "Add the first item to this variant group.",
                        "editItemTitle": "Edit Item",
                        "newItemTitle": "New Item",
                        "itemNamePlaceholder": "Live & On-Demand",
                        "saveGroupBeforeItem": "Save the variant group before adding an item",
                        "itemUpdateOk": "Item updated",
                        "itemCreateOk": "Item added",
                        "itemTitleRequired": "Please fill in all item titles",
                        "itemSaveFail": "An error occurred while saving the items",
                        "reorderPartialFail": "Some items could not be sorted, refreshing the list",
                        "reorderOk": "Sort order updated",
                        "reorderFail": "Sort order could not be saved"
                    },
                    "productGroups": {
                        "optionGroups": "Option Groups",
                        "variantGroups": "Variant Groups",
                        "detailGroups": "Detail Groups",
                        "notDefined": "Not defined",
                        "addTitle": "New Product Group",
                        "editTitle": "Edit Product Group",
                        "codeLabel": "Code",
                        "nameLabel": "Name",
                        "namePlaceholder": "Product group name",
                        "supportedGroups": "Supported Groups",
                        "optionGroupPlaceholder": "Select an option group",
                        "variantGroupPlaceholder": "Select a variant group",
                        "detailGroupPlaceholder": "Select a detail group",
                        "modules": "Modules",
                        "modulePlaceholder": "Select a module",
                        "cols": {
                            "code": "Code",
                            "name": "Name"
                        }
                    }
                },
                "save": {
                    "addTitle": "New Product",
                    "editTitle": "Edit Product",
                    "subtitle": "Enter and save the product information.",
                    "generalInformation": "General Information",
                    "productGroup": "Product Group",
                    "groupLocked": "The product group cannot be changed after it is created.",
                    "productType": "Product Type",
                    "titleLabel": "Title",
                    "titlePlaceholder": "Product title",
                    "categories": "Categories",
                    "taxes": "Taxes",
                    "brand": "Brand",
                    "attributeSet": "Attribute Set",
                    "attributeSetInherit": "Inherit from category",
                    "attributeSetHint": "If left empty, the category's set is used.",
                    "shortDescription": "Short Description",
                    "shortDescriptionPlaceholder": "Short description shown in lists and cards",
                    "showInList": "Show in List",
                    "showInListHint": "Show in product lists.",
                    "showInPopular": "Show in Popular",
                    "showInPopularHint": "Show in the popular products section.",
                    "priceRequired": "You must enter at least one price.",
                    "tags": "Tags",
                    "tagsPlaceholder": "Type a tag and press Enter",
                    "sort": "Order",
                    "mainImage": "Main Image",
                    "content": "Content",
                    "contentPlaceholder": "Product description",
                    "pricing": "Pricing",
                    "addPrice": "Add Price",
                    "price": "Price",
                    "discounted": "Discounted",
                    "datesAndStock": "Dates & Stock",
                    "saleStart": "Sale Start",
                    "saleEnd": "Sale End",
                    "usageStart": "Usage Start",
                    "usageEnd": "Usage End",
                    "selectDate": "Select a date",
                    "maxUsageDay": "Max. Usage (Days)",
                    "stock": "Stock",
                    "trackStock": "Track Stock",
                    "trackStockHint": "When off, the product is not subject to stock control (virtual products).",
                    "currentStock": "Current Stock",
                    "variantStockNote": "combination total",
                    "errTitleRequired": "Product title is required.",
                    "errContentRequired": "Product content (description) is required.",
                    "errPriceRequired": "Enter at least one valid price (currency + amount).",
                    "langSelectHint": "Translation fields (title, content, SEO) are edited for the selected language.",
                    "viewOnSite": "View product on site",
                    "stockMovements": "Stock movements",
                    "initialWarehouse": "Initial Warehouse",
                    "initialStock": "Opening Stock",
                    "stockCode": "Stock Code",
                    "shippingWeight": "Shipping Weight (kg)",
                    "shipping": "Shipping",
                    "keywords": "Keywords",
                    "keywordsPlaceholder": "keyword1, keyword2",
                    "metaTitlePlaceholder": "Meta title",
                    "metaDescPlaceholder": "Meta description",
                    "googlePreview": "Google Preview",
                    "previewHint": "The title is truncated at ~60 and the description at ~160 characters. The preview is representative.",
                    "yourStore": "Your Store",
                    "previewDescFallback": "When a description is entered for this product, it will appear here.",
                    "notFound": "Product not found, you have been redirected to the new product screen."
                }
            },
            "discount": {
                "couponCodes": {
                    "addTitle": "New Coupon",
                    "editTitle": "Edit Coupon",
                    "generalInfo": "Coupon Information",
                    "type": "Creation Type",
                    "typeSingle": "Single",
                    "typeMulti": "Bulk",
                    "typeMultiHint": "In bulk generation, codes are generated automatically and downloaded as Excel.",
                    "codeLabel": "Coupon Code",
                    "codePlaceholder": "e.g. WELCOME10",
                    "generate": "Generate Code",
                    "count": "Count",
                    "countPlaceholder": "e.g. 100",
                    "discountType": "Discount Type",
                    "discountStatic": "Fixed (₺)",
                    "discountPercent": "Percentage (%)",
                    "discountValue": "Discount Value",
                    "minAmount": "Minimum Cart Amount",
                    "limits": "Usage Limits",
                    "totalUseLimit": "Total Usage Limit",
                    "userUseLimit": "Limit Per User",
                    "unlimitedHint": "Unlimited if left empty.",
                    "cannotCombined": "Cannot be combined with other coupons",
                    "dates": "Validity Dates",
                    "startDate": "Start Date",
                    "endDate": "End Date",
                    "datePlaceholder": "Select a date",
                    "immutableHint": "The code, discount type and value cannot be changed after creation.",
                    "createOk": "Coupon created",
                    "multiCreateOk": "Coupons created and Excel downloaded",
                    "updateOk": "Coupon updated",
                    "unlimited": "Unlimited",
                    "cols": {
                        "code": "Code",
                        "type": "Type",
                        "value": "Value",
                        "used": "Usage",
                        "dates": "Dates"
                    }
                }
            }
        },
        "site": {
            "content": {
                "themes": {
                    "loading": "Loading…",
                    "notFound": "Theme not found.",
                    "activate": "Activate",
                    "activating": "Activating…",
                    "activateSuccess": "Theme activated",
                    "actionFailed": "Action failed",
                    "customizeTheme": "Customize Theme",
                    "settingsButton": "Settings",
                    "allThemes": "All Themes",
                    "activeTheme": "Active Theme",
                    "intro": {
                        "around": "Around is a modern, multi-purpose e-commerce theme. With its extensive component library, fast-loading pages and mobile-friendly design, it gives your store a sleek and professional look."
                    },
                    "settings": {
                        "title": "Theme Settings",
                        "description": "Configure the theme's color and appearance settings.",
                        "theme": "Theme",
                        "empty": "There are no settings for this theme."
                    }
                },
                "themeBuilder": {
                    "title": "Page Editor",
                    "description": "Select a page and arrange components with drag-and-drop, preview and publish.",
                    "pages": "Pages",
                    "pagesHint": "Select a page to edit.",
                    "noPages": "No customizable pages.",
                    "blocks": "Components",
                    "backToPages": "Back to pages",
                    "addComponent": "Add Component",
                    "addToZone": "Add a component to this zone",
                    "palette": "Component Palette",
                    "paletteHint": "Click a component to add it.",
                    "noComponents": "No suitable component for this zone.",
                    "emptyZone": "This zone is empty — add a component below.",
                    "editBlock": "Edit Component",
                    "blockSettings": "Component Settings",
                    "language": "Language",
                    "spacing": "Spacing (px)",
                    "spacingPt": "Top padding",
                    "spacingPb": "Bottom padding",
                    "spacingMt": "Top margin",
                    "spacingMb": "Bottom margin",
                    "duplicate": "Duplicate",
                    "remove": "Remove",
                    "removeBlockConfirm": "Remove this component?",
                    "status": "Status",
                    "draft": "Draft",
                    "published": "Published",
                    "saveDraft": "Save Draft",
                    "saving": "Saving…",
                    "autoSaved": "Saved",
                    "autoSavePending": "Pending…",
                    "publish": "Publish",
                    "publishing": "Publishing…",
                    "publishConfirm": "Publish the draft? The currently published content will change.",
                    "preview": "Preview",
                    "deviceDesktop": "Desktop",
                    "deviceTablet": "Tablet",
                    "deviceMobile": "Mobile",
                    "goToSite": "Go to site",
                    "openInNewTab": "Open draft in a new tab",
                    "refreshPreview": "Refresh preview",
                    "previewPlaceholder": "Select a page to preview.",
                    "previewLoading": "Generating preview…",
                    "previewEmpty": "No components to preview.",
                    "previewUnavailable": "Preview is currently unavailable.",
                    "relationId": "Relation Record",
                    "relationDefault": "All categories (default)",
                    "relationDefaultProduct": "All products (default) · search or enter id",
                    "relationDefaultBlog": "All blog posts (default) · search or enter id",
                    "relationDefaultPage": "All pages (default) · search or enter id",
                    "relationScopeDefault": "Editing the default layout — applies to all records.",
                    "relationScopeOverride": "Editing a record-specific layout (overrides the default).",
                    "unsavedChanges": "There are unsaved changes.",
                    "loadFailed": "The page layout could not be loaded.",
                    "saveOk": "Draft saved.",
                    "saveFailed": "Draft could not be saved.",
                    "publishOk": "Page published.",
                    "publishFailed": "Could not be published.",
                    "category": "Category"
                },
                "slider": {
                    "addTitle": "New Slider Group",
                    "editTitle": "Edit Slider Group",
                    "groupInfo": "Group Information",
                    "aliasLabel": "Alias",
                    "actions": {
                        "slides": "Slides"
                    },
                    "cols": {
                        "alias": "Alias",
                        "itemsCount": "Slide Count"
                    },
                    "items": {
                        "title": "Slides",
                        "subtitle": "Manage the slide content of Group #{id}.",
                        "buttons": "Buttons",
                        "addTitle": "New Slide",
                        "editTitle": "Edit Slide",
                        "content": "Content",
                        "titleLabel": "Title",
                        "titlePlaceholder": "Slide title",
                        "shortTitle": "Short Title",
                        "shortTitlePlaceholder": "Short title",
                        "description": "Description",
                        "link": "Link (slug)",
                        "imageSettings": "Image & Settings",
                        "scheduleSettings": "Schedule & Visibility",
                        "image": "Image",
                        "imagePerLangHint": "You can choose a separate image per language. If left empty, the other language's image is used.",
                        "imageRequired": "An image must be selected for the primary language.",
                        "startDate": "Start Date",
                        "endDate": "End Date",
                        "datePlaceholder": "Select a date",
                        "sort": "Order",
                        "slideButtons": "Slide Buttons",
                        "editButton": "Edit Button",
                        "newButton": "New Button",
                        "buttonText": "Button text",
                        "icon": "Icon",
                        "definedButtons": "Defined Buttons",
                        "loading": "Loading…",
                        "noButtons": "No buttons added yet.",
                        "cols": {
                            "image": "Image",
                            "title": "Title",
                            "dates": "Dates",
                            "sort": "Order",
                            "buttons": "Buttons"
                        }
                    }
                },
                "seo": {
                    "title": "SEO",
                    "metaTitle": "Meta Title",
                    "metaTitlePlaceholder": "Meta title",
                    "metaDescription": "Meta Description",
                    "metaDescriptionPlaceholder": "Meta description",
                    "metaKeywords": "Meta Keywords",
                    "metaKeywordsPlaceholder": "comma separated"
                },
                "blogCategories": {
                    "title": "Blog Categories",
                    "subtitle": "Create and manage blog categories.",
                    "addTitle": "New Category",
                    "editTitle": "Edit Category",
                    "general": "General",
                    "titleLabel": "Title",
                    "titlePlaceholder": "Category name",
                    "slug": "Slug",
                    "description": "Description",
                    "sort": "Order",
                    "breadcrumb": "Categories",
                    "cols": {
                        "title": "Title",
                        "postsCount": "Post Count"
                    }
                },
                "blog": {
                    "addTitle": "New Blog Post",
                    "editTitle": "Edit Blog Post",
                    "content": "Content",
                    "titleLabel": "Title",
                    "titlePlaceholder": "Blog title",
                    "slug": "Slug",
                    "categories": "Categories",
                    "selectCategory": "Select a category",
                    "image": "Image",
                    "summary": "Summary",
                    "summaryPlaceholder": "Short description",
                    "contentPlaceholder": "Blog content",
                    "sort": "Order",
                    "cols": {
                        "image": "Image",
                        "title": "Title",
                        "categories": "Categories"
                    }
                },
                "pages": {
                    "addTitle": "New Page",
                    "editTitle": "Edit Page",
                    "content": "Content",
                    "titleLabel": "Title",
                    "titlePlaceholder": "Page title",
                    "slug": "Slug",
                    "image": "Cover Image",
                    "contentPlaceholder": "Page content (HTML)",
                    "sort": "Sort",
                    "pageWidth": "Page Width",
                    "widths": {
                        "normal": "Normal",
                        "large": "Large",
                        "full": "Full Width"
                    },
                    "cols": {
                        "title": "Title",
                        "slug": "Slug"
                    }
                },
                "faq": {
                    "categoriesAction": "Categories",
                    "addTitle": "New Group",
                    "editTitle": "Edit Group",
                    "groupInfo": "Group Information",
                    "code": "Code",
                    "name": "Name",
                    "namePlaceholder": "e.g. General Questions",
                    "cols": {
                        "code": "Code",
                        "name": "Name",
                        "questionsCount": "Question Count"
                    }
                },
                "faqCategories": {
                    "title": "FAQ Categories",
                    "subtitle": "Manage the categories of Group #{id}.",
                    "questionsAction": "Questions",
                    "addTitle": "New Category",
                    "editTitle": "Edit Category",
                    "categoryInfo": "Category Information",
                    "titleLabel": "Title",
                    "titlePlaceholder": "Category name",
                    "slug": "Slug",
                    "description": "Description",
                    "sort": "Order",
                    "breadcrumb": "Categories",
                    "cols": {
                        "title": "Title",
                        "questionsCount": "Question Count"
                    }
                },
                "faqQuestions": {
                    "title": "Questions",
                    "subtitle": "Manage the questions of Category #{id}.",
                    "addTitle": "New Question",
                    "editTitle": "Edit Question",
                    "questionAnswer": "Question & Answer",
                    "question": "Question",
                    "questionPlaceholder": "Question text",
                    "answer": "Answer",
                    "answerPlaceholder": "Answer text",
                    "sort": "Order",
                    "cols": {
                        "question": "Question",
                        "answer": "Answer",
                        "sort": "Order"
                    }
                },
                "featuredProducts": {
                    "productsAction": "Products",
                    "addTitle": "New Group",
                    "editTitle": "Edit Group",
                    "groupInfo": "Group Information",
                    "name": "Name",
                    "namePlaceholder": "e.g. IELTS",
                    "titleLabel": "Title",
                    "titlePlaceholder": "Showcase title",
                    "description": "Description",
                    "sort": "Order",
                    "cols": {
                        "name": "Name",
                        "title": "Title",
                        "productsCount": "Product Count"
                    }
                },
                "featuredProductsItems": {
                    "title": "Featured Products",
                    "subtitle": "Manage the featured products for Group #{id}.",
                    "addTitle": "New Featured Product",
                    "editTitle": "Edit Featured Product",
                    "productInfo": "Product Information",
                    "product": "Product",
                    "selectProduct": "Select a product",
                    "productLocked": "The product cannot be changed after it is created.",
                    "tag": "Tag (watch_tag)",
                    "tagPlaceholder": "e.g. Online",
                    "description": "Description",
                    "descriptionPlaceholder": "Optional description",
                    "sort": "Order",
                    "breadcrumb": "Products",
                    "cols": {
                        "product": "Product",
                        "tag": "Tag",
                        "sort": "Order"
                    }
                },
                "forms": {
                    "elementsAction": "Fields",
                    "answersAction": "Responses",
                    "addTitle": "New Form",
                    "editTitle": "Edit Form",
                    "general": "General",
                    "titleLabel": "Title",
                    "titlePlaceholder": "Form title",
                    "slug": "Slug",
                    "description": "Description",
                    "image": "Image",
                    "redirectUrl": "Redirect URL after response",
                    "redirectUrlPlaceholder": "https://... (optional)",
                    "cols": {
                        "title": "Title",
                        "manage": "Manage"
                    }
                },
                "formElements": {
                    "title": "Form Fields",
                    "subtitle": "Manage the fields of Form #{id}.",
                    "addTitle": "New Field",
                    "editTitle": "Edit Field",
                    "fieldInfo": "Field Information",
                    "fieldType": "Field Type",
                    "selectType": "Select a type",
                    "titleLabel": "Title",
                    "titlePlaceholder": "e.g. Your Full Name",
                    "description": "Description",
                    "helpText": "Help text",
                    "placeholder": "Placeholder",
                    "placeholderHint": "Hint text",
                    "sort": "Order",
                    "advanced": "Advanced",
                    "advancedHint": "Validation/options in JSON format. e.g. validation:",
                    "validationOptions": "Validation / Options (options)",
                    "itemsLabel": "Items (items) — for selection types",
                    "itemsPlaceholder": "[\"Option 1\",\"Option 2\"]",
                    "breadcrumb": "Fields",
                    "invalidJson": "The options / items field must be valid JSON",
                    "cols": {
                        "type": "Type",
                        "title": "Title",
                        "sort": "Order"
                    }
                },
                "formAnswers": {
                    "title": "Form Responses",
                    "subtitle": "View the responses of Form #{id}.",
                    "view": "View",
                    "answerDetail": "Response Detail",
                    "loading": "Loading…",
                    "ip": "IP",
                    "dateLabel": "Date",
                    "browser": "Browser",
                    "answers": "Answers",
                    "noAnswers": "No answers.",
                    "breadcrumb": "Responses",
                    "exportFailed": "Export failed",
                    "cols": {
                        "ip": "IP",
                        "answersCount": "Answer Count",
                        "date": "Date"
                    }
                },
                "links": {
                    "hiddenInSearch": "Hidden in search",
                    "hiddenInSitemap": "Hidden in sitemap",
                    "addTitle": "New Redirect",
                    "editTitle": "Edit Link",
                    "link": "Link",
                    "content": "Content",
                    "redirectType": "Redirect Type",
                    "permanentRedirect": "Permanent Redirect (301)",
                    "temporaryRedirect": "Temporary Redirect (302)",
                    "slug": "Slug",
                    "redirect": "Redirect",
                    "targetSlug": "target-link",
                    "targetSlugOptional": "target-link (optional)",
                    "redirectHint": "This slug is redirected to the target slug.",
                    "searchEngine": "Search Engine",
                    "hideInSearch": "Hide in search (noindex)",
                    "hideInSitemap": "Hide in sitemap",
                    "cols": {
                        "language": "Language",
                        "type": "Type",
                        "content": "Content",
                        "slug": "Slug",
                        "redirect": "Redirect",
                        "flags": "Flags"
                    }
                },
                "menus": {
                    "addTitle": "New Menu",
                    "editTitle": "Edit Menu",
                    "namePlaceholder": "e.g. Main Menu (Header)",
                    "codeImmutable": "The code cannot be changed after creation (the HEADER/FOOTER component uses this code).",
                    "editItems": "Edit items",
                    "builderTitle": "Menu Builder",
                    "builderHint": "Drag items to reorder them; move them to lower levels to build a dropdown/mega structure.",
                    "addItem": "Add Item",
                    "newItem": "New Item",
                    "editItem": "Edit Item",
                    "empty": "No items in this menu yet",
                    "emptyHint": "Add your first item; you can set it up as a link, dropdown, or mega menu.",
                    "savingOrder": "Saving order…",
                    "titlePlaceholder": "e.g. Home",
                    "titleRequired": "Enter a title in at least one language.",
                    "perLanguage": "Content by Language",
                    "urlHint": "Link address. e.g. /, /campaign, https://...",
                    "urlContainerHint": "Usually left empty (becomes #) for container items (dropdown/mega/column).",
                    "deleteConfirm": "This item and all its sub-items will be deleted. Are you sure?",
                    "types": {
                        "LINK": "Link",
                        "DROPDOWN": "Dropdown",
                        "MEGA": "Mega Menu",
                        "COLUMN": "Column",
                        "PRODUCTS": "Product Cards"
                    },
                    "cols": {
                        "code": "Code",
                        "name": "Name",
                        "items": "Item Count",
                        "type": "Type",
                        "title": "Title",
                        "url": "URL",
                        "columns": "Column Count"
                    }
                },
                "popup": {
                    "buttonsAction": "Buttons",
                    "addTitle": "New Popup",
                    "editTitle": "Edit Popup",
                    "drawerSubtitle": "Appearance, scheduling and targeting settings",
                    "general": "General",
                    "titleLabel": "Title",
                    "titlePlaceholder": "Popup title",
                    "contentLabel": "Content",
                    "contentPlaceholder": "Popup content",
                    "scheduling": "Scheduling",
                    "startDate": "Start Date",
                    "endDate": "End Date",
                    "datePlaceholder": "Select a date",
                    "displaySettings": "Display Settings",
                    "popupType": "Popup Type",
                    "typeContent": "Content",
                    "typeImage": "Image",
                    "repeatDays": "Repeat (days)",
                    "delaySeconds": "Delay (sec)",
                    "sticky": "Sticky",
                    "stickyDuration": "Sticky duration (sec)",
                    "dontShowAgain": "\"Don't show again\"",
                    "hideHeader": "Hide header",
                    "hideFooter": "Hide footer",
                    "sort": "Order",
                    "visibility": "Visibility (Page Targeting)",
                    "visibilityHint": "For ID: <b>0</b> root, <b>-1</b> all of the related type.",
                    "routeSection": "Pages",
                    "userLabelSection": "User Labels",
                    "pagesToShow": "Pages to show",
                    "pagesToHide": "Pages to hide",
                    "labelsToShow": "Labels to show",
                    "labelsToHide": "Labels to hide",
                    "noRule": "No rules.",
                    "noRuleShow": "No rule (shown everywhere).",
                    "noRuleHide": "No rule.",
                    "allHint": "type_id: the ID of a specific record; -1 = all pages of this type.",
                    "type": "Type",
                    "popupButtons": "Popup Buttons",
                    "editButton": "Edit Button",
                    "newButton": "New Button",
                    "buttonText": "Button text",
                    "link": "Link (slug)",
                    "definedButtons": "Defined Buttons",
                    "loading": "Loading…",
                    "noButtons": "No buttons added yet.",
                    "cols": {
                        "title": "Title",
                        "dates": "Dates",
                        "buttons": "Buttons"
                    }
                }
            },
            "administrators": {
                "admins": {
                    "addTitle": "New Administrator",
                    "editTitle": "Edit Administrator",
                    "accountInfo": "Account Information",
                    "selectGroup": "Select a group",
                    "currentPassword": "Current Password",
                    "ifRequired": "(if required)",
                    "newPassword": "New Password",
                    "newPasswordConfirm": "New Password (Confirm)",
                    "newPasswordConfirmPlaceholder": "Confirm new password",
                    "cols": {
                        "firstname": "First Name",
                        "lastname": "Last Name",
                        "fullname": "Full Name",
                        "email": "Email",
                        "group": "Group",
                        "password": "Password"
                    }
                },
                "groups": {
                    "addTitle": "New Group",
                    "editTitle": "Edit Group",
                    "groupInfo": "Group Information",
                    "permissions": "Permissions",
                    "duplicate": "Duplicate",
                    "duplicateConfirm": "Do you want to duplicate the \"{name}\" group?",
                    "duplicateSuccess": "Group duplicated",
                    "namePlaceholder": "e.g. Editor",
                    "optionalPlaceholder": "(optional)",
                    "cols": {
                        "name": "Name",
                        "code": "Code",
                        "users": "Users"
                    }
                },
                "permissions": {
                    "title": "Permission Management",
                    "groupPermissions": "Permissions of group {name}",
                    "groupNumber": "Group #{id}",
                    "endpointPermissions": "Endpoint Permissions",
                    "searchPlaceholder": "Search…",
                    "loading": "Loading…",
                    "notFound": "Endpoint not found.",
                    "endpoint": "Endpoint",
                    "otherGroup": "Other",
                    "saveFailed": "Could not be saved",
                    "selectAllGroup": "Select / clear entire group"
                }
            },
            "localization": {
                "currencies": {
                    "addTitle": "New Currency",
                    "editTitle": "Edit Currency",
                    "currencyInfo": "Currency Information",
                    "prefix": "Prefix",
                    "suffix": "Suffix",
                    "commissionRate": "Commission / Rate",
                    "cols": {
                        "code": "Code",
                        "name": "Name",
                        "symbol": "Symbol",
                        "commission": "Commission"
                    }
                },
                "languages": {
                    "addTitle": "New Language",
                    "editTitle": "Edit Language",
                    "languageInfo": "Language Information",
                    "cols": {
                        "code": "Code",
                        "name": "Name"
                    }
                },
                "taxes": {
                    "addTitle": "New Tax",
                    "editTitle": "Edit Tax",
                    "taxInfo": "Tax Information",
                    "selectCountry": "Select a country",
                    "ratePercent": "Rate (%)",
                    "sort": "Order",
                    "cols": {
                        "country": "Country",
                        "code": "Code",
                        "name": "Name",
                        "rate": "Rate"
                    }
                },
                "countries": {
                    "title": "Countries",
                    "states": "States",
                    "cities": "Districts",
                    "searchCountry": "Search country...",
                    "searchState": "Search state...",
                    "searchCity": "Search districts...",
                    "viewStates": "View states",
                    "viewCities": "View districts",
                    "statesOf": "States of {name}",
                    "citiesOf": "{name} districts",
                    "addCountry": "New Country",
                    "editCountry": "Edit Country",
                    "addState": "New State",
                    "editState": "Edit State",
                    "addCity": "New District",
                    "editCity": "Edit District",
                    "countryInfo": "Country Details",
                    "stateInfo": "State Info",
                    "cityInfo": "District Info",
                    "emptyStates": "This country has no states.",
                    "emptyCities": "There are no districts for this city.",
                    "cols": {
                        "id": "ID",
                        "name": "Name",
                        "isoCode2": "ISO Code (2)",
                        "isoCode3": "ISO Code (3)",
                        "currency": "Currency",
                        "stateCount": "State Count"
                    }
                }
            },
            "settings": {
                "mediaProviders": {
                    "addTitle": "New Provider",
                    "editTitle": "Edit Provider",
                    "providerInfo": "Provider Information",
                    "accounts": "Accounts",
                    "codeImmutable": "The code cannot be changed after creation.",
                    "namePlaceholder": "e.g. Vimeo",
                    "cols": {
                        "code": "Code",
                        "name": "Name",
                        "platforms": "Platforms",
                        "accountsCount": "Account Count"
                    }
                },
                "mediaProvider": {
                    "description": "Manage provider accounts and credentials.",
                    "providers": "Providers",
                    "accounts": "Accounts",
                    "addTitle": "New Account",
                    "editTitle": "Edit Account",
                    "accountInfo": "Account Information",
                    "titlePlaceholder": "e.g. Main Account",
                    "credentials": "Credentials",
                    "credentialsHint": "For security, existing values are not shown. Leave blank if you do not want to change them.",
                    "noCredentialFields": "There are no credential fields defined for this provider.",
                    "cols": {
                        "title": "Title"
                    }
                },
                "siteSetting": {
                    "title": "Site & Homepage Settings",
                    "empty": "No setting fields defined."
                },
                "systemSetting": {
                    "title": "Registration Settings",
                    "empty": "No setting fields defined."
                },
                "registerElements": {
                    "title": "Registration Form Fields",
                    "addTitle": "New Field",
                    "editTitle": "Edit Field",
                    "nameLabel": "Field Name (name)",
                    "nameHint": "Key name of the field (e.g. tax_number, phone). Cannot be changed after creation.",
                    "optionsTitle": "Options",
                    "inputType": "Input Type",
                    "required": "Required field",
                    "multiple": "Multiple selection",
                    "items": "Options",
                    "itemText": "Label",
                    "itemValue": "Value (optional)",
                    "addItem": "Add option",
                    "itemsRequired": "At least one option is required for this field type.",
                    "inputTypes": {
                        "text": "Text",
                        "email": "Email",
                        "password": "Password",
                        "number": "Number",
                        "tel": "Phone",
                        "url": "URL",
                        "radio": "Single choice (radio)",
                        "checkbox": "Checkbox"
                    },
                    "typeNames": {
                        "input": "Input",
                        "textarea": "Textarea",
                        "select": "Dropdown",
                        "radio_group": "Radio Group",
                        "checkbox_group": "Checkbox Group",
                        "state": "Province",
                        "city": "District"
                    }
                },
                "systemVariables": {
                    "addTitle": "New Variable",
                    "editTitle": "Edit Variable",
                    "variable": "Variable",
                    "codeImmutable": "The code cannot be changed after creation.",
                    "descriptionPlaceholder": "Optional description",
                    "cols": {
                        "code": "Code",
                        "value": "Value",
                        "description": "Description"
                    }
                },
                "trackingCodes": {
                    "addTitle": "New Tracking Code",
                    "editTitle": "Edit Tracking Code",
                    "codeInfo": "Code Information",
                    "namePlaceholder": "e.g. Google Analytics",
                    "selectLocation": "Select a location",
                    "contentLabel": "Content (code)",
                    "visibility": "Visibility (Page Targeting)",
                    "visibilityHint": "For ID: <b>0</b> root, <b>-1</b> all of the related type. If left empty, it runs everywhere.",
                    "toShow": "To Show",
                    "toHide": "To Hide",
                    "type": "Type",
                    "cols": {
                        "name": "Name",
                        "location": "Location",
                        "sort": "Order"
                    }
                }
            }
        },
        "library": {
            "liveDataWarning": "You are working on live data. Please be careful when making any changes.",
            "action": {
                "selectAll": "Select all",
                "deselectAll": "Deselect all"
            },
            "menu": {
                "favorites": "Favorites",
                "trash": "Trash"
            }
        },
        "campaignsPage": {
            "drawer": {
                "editTitle": "Edit Campaign",
                "createTitle": "Create Campaign"
            },
            "sections": {
                "info": "Campaign Details",
                "discount": "Discount",
                "buyXPayY": "Buy X Pay Y",
                "targeting": "Applicable Products",
                "conditions": "Conditions",
                "validityPriority": "Validity & Priority"
            },
            "labels": {
                "name": "Campaign Name",
                "type": "Campaign Type",
                "discountType": "Discount Type",
                "discountValue": "Discount Value",
                "maxDiscount": "Maximum Discount",
                "buyQuantity": "Quantity Bought (X)",
                "payQuantity": "Quantity Paid (Y)",
                "minAmount": "Minimum Cart Amount",
                "minQuantity": "Minimum Product Quantity",
                "startDate": "Start Date",
                "endDate": "End Date",
                "priority": "Priority",
                "salesChannel": "Sales Channel",
                "cannotCombined": "Cannot be combined with other campaigns"
            },
            "types": {
                "cartDiscount": "Cart Discount",
                "productDiscount": "Product Discount",
                "buyXPayY": "Buy X Pay Y",
                "freeShipping": "Free Shipping"
            },
            "discountTypes": {
                "fixed": "Fixed Amount",
                "percent": "Percentage"
            },
            "targetModes": {
                "products": "Products",
                "categories": "Category",
                "brands": "Brand",
                "tags": "Tag"
            },
            "placeholders": {
                "name": "E.g. Summer Sale",
                "maxDiscount": "Unlimited",
                "searchProduct": "Search by product name…",
                "selectCategory": "Select category",
                "selectBrand": "Select brand",
                "selectTag": "Select tag",
                "none": "None",
                "selectDate": "Select date",
                "allChannels": "All channels"
            },
            "hints": {
                "buyXPayY": "E.g. Buy 3 Pay 2 → the cheapest 1 product is free. Matching products are taken from the targeting below.",
                "targeting": "If left empty, it applies to all products.",
                "conditions": "When the conditions are met, the campaign is applied to the cart automatically (no code required).",
                "priority": "Lower value = higher priority."
            },
            "cols": {
                "name": "Name",
                "type": "Type",
                "benefit": "Benefit",
                "condition": "Condition",
                "priority": "Priority"
            },
            "filter": {
                "name": "Campaign Name",
                "type": "Type"
            },
            "benefit": {
                "freeShipping": "Free Shipping",
                "buyXPayY": "Buy {buy} Pay {pay}"
            },
            "units": {
                "piece": "pcs"
            }
        },
        "couponCodesPage": {
            "productSectionTitle": "Where It Can Be Used",
            "userSectionTitle": "Who Can Use It",
            "include": "Include",
            "exclude": "Exclude",
            "includeHint": "Valid only for the selected items",
            "excludeHint": "Valid everywhere except the selected items",
            "productSearchPlaceholder": "Search by product name…",
            "categorySelectPlaceholder": "Select category",
            "brandSelectPlaceholder": "Select brand",
            "tagSelectPlaceholder": "Select tag",
            "customerSearchPlaceholder": "Search by customer name…",
            "userLabelSelectPlaceholder": "Select user label",
            "exportFileName": "coupons.xlsx",
            "productMode": {
                "all": "All",
                "products": "Products",
                "categories": "Category",
                "brands": "Brand",
                "tags": "Tag"
            },
            "userMode": {
                "all": "Everyone",
                "users": "Selected Customers",
                "labels": "By Label"
            }
        },
        "draftsPage": {
            "newDraft": "New Draft",
            "customerRequiredBadge": "Customer required",
            "itemsCount": "{count} items",
            "convertTooltip": "Convert to order",
            "convertBtn": "Convert to Order",
            "editTooltip": "Edit",
            "drawerTitle": "Draft Detail",
            "customerLabel": "Customer",
            "notSelected": "Not selected",
            "productsWithCount": "Products ({count})",
            "productNo": "Product #{id}",
            "pieces": "{count} pcs",
            "variant": "variant",
            "estimatedTotal": "Estimated Total",
            "customerNamePlaceholder": "Customer name",
            "columns": {
                "customer": "Customer",
                "items": "Items",
                "total": "Amount",
                "note": "Note",
                "date": "Date"
            },
            "errors": {
                "draftCustomerRequired": "No customer is selected for this draft. Edit the draft to add a customer, then convert it to an order.",
                "draftAlreadyConverted": "This draft has already been converted to an order.",
                "recordNotFound": "Draft not found.",
                "usageDateRange": "The usage end date cannot be earlier than the start date.",
                "cartEmpty": "There are no products in the draft.",
                "convertFailedWithMsg": "Could not convert to order: {msg}",
                "convertFailedGeneric": "An error occurred while converting to an order."
            },
            "customerMissingMessage": "No customer is selected for this draft. You must add a customer before converting it to an order. Would you like to edit the draft now?",
            "customerMissingHeader": "Customer Required",
            "cancel": "Cancel",
            "convertConfirmMessage": "Are you sure you want to convert the \"{name}\" draft into a real order? Stock will be reserved at this stage.",
            "orderCreated": "Order created #{id}"
        },
        "abandonedCartsPage": {
            "guest": "Guest",
            "unregisteredSession": "Unregistered / session",
            "productsWord": "products",
            "itemsWord": "items",
            "recoverable": "Recoverable",
            "recoverability": "Recoverability",
            "detail": "Detail",
            "goToCustomer": "Go to customer",
            "goToCustomerBtn": "Go to Customer",
            "cartDetail": "Cart Detail",
            "customer": "Customer",
            "cartProducts": "Products in Cart",
            "cartTotal": "Cart Total",
            "abandonedAgo": "abandoned {duration} ago",
            "searchPlaceholder": "Name / email",
            "abandonStage": "Abandonment stage",
            "lastActivity": "Last activity",
            "column": {
                "customer": "Customer",
                "products": "Products",
                "amount": "Amount",
                "abandonDuration": "Abandonment Time"
            },
            "duration": {
                "justNow": "just now",
                "minutes": "min",
                "hour": "h",
                "minShort": "min",
                "day": "d"
            },
            "stage": {
                "active": "Active",
                "stage1": "1 hour+",
                "stage2": "1 day+",
                "stage3": "3 days+ · last chance",
                "lost": "7 days+ · lost"
            },
            "filterStage": {
                "active": "Active (<1 hour)",
                "stage1": "1 hour+ (first reminder)",
                "stage2": "1 day+ (second reminder)",
                "stage3": "3 days+ (last chance)",
                "lost": "7 days+ (lost)"
            }
        },
        "barcodePage": {
            "print": "Print",
            "addProduct": "Add Product",
            "searchPlaceholder": "Type at least 2 letters...",
            "variantHint": "Products with variants are split into a separate label per combination.",
            "labelSettings": "Label Settings",
            "labelsPerRow": "Labels per row",
            "showName": "Show product name",
            "showPrice": "Show price",
            "showSku": "Show SKU",
            "labels": "Labels",
            "clearAll": "Clear all",
            "bulkQty": "Bulk quantity:",
            "applyToAll": "Apply to all",
            "incEach": "+1 to each label",
            "decEach": "-1 from each label",
            "toAll": "To all",
            "totalPrefix": "Total",
            "labelWord": "labels",
            "colProduct": "Product",
            "colBarcode": "Barcode",
            "colQuantity": "Quantity",
            "emptyTitle": "No labels added yet",
            "emptyText": "Search and add a product from the left panel to print. Products with variants are split into a separate label per combination.",
            "preview": "Preview",
            "popupBlocked": "Could not open the print window (a pop-up blocker may be active).",
            "printTitle": "Barcode Labels"
        },
        "campaignOffersPage": {
            "drawer": {
                "editTitle": "Edit Offers",
                "addTitle": "Add Campaign Offer"
            },
            "form": {
                "productLabel": "Product",
                "productSearchPlaceholder": "Search by product name…",
                "productHint": "Recommendations to be shown on this product's detail page.",
                "crossSellTitle": "Cross-Sell (Complementary Products)",
                "crossSellHint": "\"Bought together\" — complementary products to suggest alongside this product.",
                "upSellTitle": "Up-Sell (Better Product)",
                "upSellHint": "\"Instead of this\" — higher-tier / better alternative suggestions.",
                "productAddPlaceholder": "Search and add product…"
            },
            "columns": {
                "product": "Product",
                "crossSell": "Cross-Sell",
                "upSell": "Up-Sell"
            },
            "filters": {
                "productName": "Product Name"
            }
        },
        "priceListSavePage": {
            "title": {
                "edit": "Edit Price List",
                "new": "New Price List"
            },
            "subtitle": "B2B price list — pricing specific to customer group/tag",
            "cancel": "Cancel",
            "save": "Save",
            "loading": "Loading...",
            "listInfo": "List Information",
            "listName": "List Name",
            "listNamePlaceholder": "e.g. Wholesale Prices",
            "listNameRequired": "List name is required.",
            "generalDiscount": "General Discount (%)",
            "priority": "Priority",
            "status": "Status",
            "active": "Active",
            "passive": "Passive",
            "generalDiscountHint": "The general discount applies to all products without a product-specific price.",
            "targetAudience": "Target Audience",
            "customerGroups": "Customer Groups",
            "selectGroup": "Select group",
            "customerTags": "Customer Tags",
            "selectTag": "Select tag",
            "targetRequired": "Select at least one customer group or tag.",
            "targetHint": "Logged-in customers with this group <b>or</b> tag will see the list price.",
            "productsAndPrices": "Products & Prices",
            "fetchByFilterTitle": "Fetch products by category / brand / tag",
            "fetchProducts": "Fetch Products",
            "fetching": "Fetching",
            "or": "or",
            "searchSingleProduct": "Search single product…",
            "all": "All",
            "applyToSelected": "Apply to selected:",
            "percentRatePlaceholder": "% rate",
            "pricePlaceholder": "Price",
            "apply": "Apply",
            "removeSelected": "Remove Selected",
            "searchProduct": "Search product…",
            "listPrice": "List price:",
            "allProduct": "Whole product",
            "selectVariant": "Select variant",
            "noVariant": "— no variant",
            "emptyTitle": "No products added yet",
            "emptyText": "Bulk-fetch products by category, brand or tag above, or search and add them one by one. Then select and apply a bulk discount.",
            "breadcrumb": "Price List",
            "edit": "Edit",
            "new": "New",
            "filters": {
                "category": "Category",
                "brand": "Brand",
                "productTag": "Product tag"
            },
            "cols": {
                "product": "Product",
                "variant": "Variant",
                "priceDiscount": "Price / Discount",
                "fixed": "Fixed ₺",
                "percentDiscount": "% Discount"
            },
            "msg": {
                "alreadyInList": "This product is already in the list.",
                "productsAdded": "{count} products added. You can apply a bulk discount to selected products.",
                "noNewProducts": "No new products to add (already in list or no match).",
                "first500": "First 500 products fetched — narrow the filter for more.",
                "appliedToProducts": "Applied to {count} products.",
                "badRows": "{count} product rows have missing/invalid fields — enter a product and a valid price/rate."
            }
        },
        "priceListPage": {
            "cols": {
                "list": "List",
                "discount": "Discount",
                "target": "Target",
                "specialPrice": "Special Price",
                "discountSuffix": "off",
                "itemsSuffix": "special prices"
            },
            "filters": {
                "listName": "List Name"
            },
            "msg": {
                "targetNotAssigned": "No target assigned"
            }
        },
        "cartLinksPage": {
            "cols": {
                "title": "Title",
                "items": "Products",
                "coupon": "Coupon",
                "stats": "Stats",
                "expires": "Expires"
            },
            "code": "Code",
            "product": "products",
            "viewCount": "Views",
            "orderCount": "Orders",
            "copyUrl": "Copy URL",
            "addTitle": "Create Cart Link",
            "editTitle": "Edit Cart Link",
            "general": "General",
            "titlePlaceholder": "e.g. Campaign cart",
            "titleHint": "Not shown to the customer, for your reference only.",
            "searchCoupon": "Search coupon code...",
            "noExpiry": "No expiry",
            "itemsTitle": "Products",
            "addProduct": "Add Product",
            "noItems": "No products added yet",
            "searchProduct": "Search product...",
            "selectVariant": "Select variant",
            "noVariant": "No variant",
            "personalizations": "Personalizations",
            "fileNotSupported": "File field is not supported here",
            "requiredFileBlock": "Required file field cannot be filled here",
            "fillRequiredPers": "Fill in the required personalization fields",
            "urlCopied": "URL copied to clipboard",
            "itemError": "Row {row}: {error}",
            "errors": {
                "personalizationRequired": "Row {row}: '{name}' personalization is required",
                "requiredVariant": "Row {row}: Variant selection is required",
                "invalidVariant": "Row {row}: Invalid variant",
                "invalidProduct": "Row {row}: Invalid product",
                "invalidQuantity": "Row {row}: Invalid quantity",
                "invalidPersValue": "Row {row}: Invalid personalization value",
                "unsupportedPers": "Row {row}: Unsupported personalization for the product",
                "persValueTooLong": "Row {row}: Personalization value is too long",
                "persDependencyNotMet": "Row {row}: Personalization dependency not met"
            }
        },
        "pendingApprovalPage": {
            "cols": {
                "customerGroup": "Customer Group"
            },
            "filters": {
                "searchPlaceholder": "Name / email"
            },
            "btn": {
                "approve": "Approve",
                "reject": "Reject"
            },
            "confirm": {
                "approveHeader": "B2B Approval",
                "approveMessage": "Are you sure you want to approve the B2B account of \"{name}\"?",
                "rejectHeader": "B2B Rejection",
                "rejectMessage": "Are you sure you want to reject the B2B application of \"{name}\"?"
            },
            "msg": {
                "approved": "Customer approved (Account Created).",
                "rejected": "Customer rejected."
            }
        },
        "customerGroupsPage": {
            "editTitle": "Edit Group",
            "addTitle": "Add Customer Group",
            "groupName": "Group Name",
            "namePlaceholder": "e.g. Wholesalers, VIP",
            "assignHint": "You can assign customers to groups from the customer edit screen.",
            "cols": {
                "name": "Group Name",
                "members": "Customer Count"
            },
            "filters": {
                "name": "Group Name"
            }
        },
        "customerListPage": {
            "filters": {
                "searchPlaceholder": "Name / e-mail",
                "customerGroup": "Customer Group",
                "b2bStatus": "B2B Status"
            },
            "cols": {
                "customerGroup": "Customer Group",
                "b2b": "B2B"
            },
            "states": {
                "b2bApproved": "Has Account",
                "b2bPending": "Pending Approval",
                "b2bRejected": "Rejected",
                "b2bNone": "Not B2B"
            }
        },
        "appDetailPage": {
            "marketBreadcrumb": "App Market",
            "statusInstalledActive": "Installed · Active",
            "statusInstalledInactive": "Installed · Inactive",
            "statusNotInstalled": "Not installed",
            "aboutTitle": "About the App",
            "connectionInfoTitle": "Connection Details",
            "setupTitle": "Setup",
            "loading": "Loading...",
            "activeLabel": "Active",
            "saveSettings": "Save Settings",
            "installApp": "Install App",
            "uninstallApp": "Uninstall App",
            "manageLabel": "Manage",
            "credentialsEncrypted": "The credentials you enter are stored encrypted.",
            "notFoundTitle": "App not found",
            "backToMarket": "Back to App Market",
            "fieldRequired": "The \"{field}\" field is required.",
            "settingsSaved": "Settings saved",
            "appInstalled": "{name} installed",
            "uninstallConfirm": "Are you sure you want to uninstall \"{name}\"?",
            "uninstallConfirmButton": "Uninstall",
            "cancel": "Cancel",
            "appUninstalled": "App uninstalled"
        }
    },
    "filters": {
        "title": "Filter Options",
        "name": "Name",
        "user": {
            "id": "User ID"
        },
        "library": {
            "id": "ID (Video or Folder)",
            "title": "Title"
        }
    },
    "components": {
        "libraryVideo": {
            "uploadTitle": "Drag videos or click to select"
        },
        "mediaPicker": {
            "remove": "Remove",
            "selectFromLibrary": "Select from Library"
        },
        "media": {
            "title": "Media Library",
            "folders": "Folders",
            "newFolder": "New folder",
            "allFiles": "All Files",
            "root": "Root",
            "loading": "Loading…",
            "searchPlaceholder": "Search by file name…",
            "move": "Move",
            "uploading": "Uploading…",
            "fileLabel": "file",
            "folderLabel": "folder",
            "fileSingular": "File",
            "rename": "Rename",
            "actions": "Actions",
            "noMediaHere": "No media in this location.",
            "cancel": "Cancel",
            "moveToFolder": "Move to Folder",
            "targetFolder": "Target folder",
            "selectFolder": "Select a folder",
            "confirm": "Confirm",
            "confirmDeleteFiles": "Delete %s files?",
            "confirmDeleteFile": "Delete this file?",
            "filesDeleted": "%s files deleted",
            "fileDeleted": "File deleted",
            "folderName": "Folder name",
            "newFolderTitle": "New Folder",
            "nameRequired": "Name is required",
            "folderCreated": "Folder created",
            "newName": "New name",
            "renameFolderTitle": "Rename Folder",
            "updated": "Updated",
            "confirmDeleteFolder": "Delete this folder? The files inside it will be moved to the parent folder.",
            "folderDeleted": "Folder deleted",
            "moved": "Moved",
            "moveFailed": "Move failed",
            "folderMoved": "Folder moved",
            "folderMoveFailed": "Folder could not be moved",
            "filesMoved": "Files moved",
            "fileMoved": "File moved",
            "uploadComplete": "Upload complete",
            "uploadFailed": "Upload failed"
        },
        "iconPicker": {
            "choose": "Choose icon",
            "clear": "Clear",
            "search": "Search icon…",
            "noResult": "No icon found"
        },
        "themeSchema": {
            "remove": "Remove",
            "item": "Item",
            "noItems": "No items yet.",
            "htmlPlaceholder": "May contain HTML",
            "unknownType": "Unknown type:",
            "labels": {
                "title": "Title",
                "subtitle": "Subtitle",
                "shortTitle": "Short Title",
                "description": "Description",
                "content": "Content",
                "poster": "Image",
                "image": "Image",
                "icon": "Icon",
                "name": "Name",
                "slug": "Slug",
                "url": "Link",
                "link": "Link",
                "items": "Items",
                "text": "Text",
                "label": "Label",
                "value": "Value",
                "group": "Group",
                "showSearch": "Search Icon",
                "showFavorites": "Favorites Icon",
                "showAccount": "Account Icon",
                "showCart": "Cart Icon",
                "showCurrency": "Currency Switcher",
                "showLanguage": "Language Switcher",
                "variant": "Layout Variant",
                "sidebar": "Sidebar",
                "button_text": "Button Text",
                "button_url": "Button URL",
                "link_text": "Link Text",
                "empty_text": "Empty State Text",
                "bg_color": "Background Color",
                "text_color": "Text Color",
                "dismissible": "Dismissible",
                "free_shipping_text": "Free Shipping Text",
                "reviews": "Reviews",
                "reviews_variant": "Reviews Layout",
                "category_ids": "Categories",
                "limit": "Item Limit",
                "fallback_title": "Fallback Title",
                "fallback_text": "Fallback Text",
                "fallback_button_text": "Fallback Button Text",
                "socials": "Social Links",
                "rate": "Rating",
                "message": "Message"
            }
        },
        "menuTree": {
            "dragToSort": "Drag to reorder / move",
            "addChild": "Add child item",
            "dropHere": "Drag sub-items here",
            "columns": "columns",
            "collapse": "Collapse sub-items",
            "expand": "Show sub-items"
        },
        "productAddons": {
            "title": "Addons",
            "description": "Define additional products that can be purchased together with this product.",
            "addAddon": "Add Addon",
            "saveProductFirst": "Save the product first",
            "saveProductFirstHint": "After the product is created, you can add addons here.",
            "noAddons": "No addons yet",
            "cols": {
                "product": "Product",
                "quantity": "Quantity",
                "price": "Price",
                "cart": "Cart"
            },
            "variant": "Variant",
            "selectVariant": "Select a variant combination",
            "variantHint": "If the addon product has more than one variant, select which one will be added.",
            "automatic": "Automatic",
            "locked": "Locked",
            "editAddon": "Edit Addon",
            "newAddon": "New Addon",
            "drawerSubtitle": "Additional product to be sold with the product",
            "cartBehavior": "Cart Behavior",
            "autoAddCart": "Add to cart automatically",
            "autoAddCartHint": "When the product is added to the cart, this addon is added too.",
            "cannotRemoveCart": "Cannot be removed from cart",
            "cannotRemoveCartHint": "The customer cannot remove this addon from the cart.",
            "prices": "Prices",
            "addPrice": "Add Price",
            "noPrices": "No price added — the main product price applies.",
            "discount": "Discount",
            "invoice": "Invoice",
            "cancel": "Cancel"
        },
        "productPersonalizations": {
            "title": "Personalization Fields",
            "description": "Define fields for customers to personalize the product (gift wrap, note, color choice…).",
            "addField": "Add Field",
            "saveProductFirst": "Save the product first",
            "saveProductFirstHint": "Once the product is created, you can add personalization fields here.",
            "noFields": "No personalization fields yet",
            "editField": "Edit Field",
            "newField": "New Field",
            "drawerSubtitle": "Field shown to the customer on the product detail page",
            "cols": {
                "field": "Field",
                "type": "Type",
                "price": "Price",
                "rules": "Rules"
            },
            "fieldTitle": "Title",
            "fieldTitlePlaceholder": "Gift Wrap",
            "fieldDescription": "Description",
            "fieldDescriptionPlaceholder": "Your product will be sent gift-wrapped",
            "types": {
                "boolean": "Yes / No",
                "select": "Select",
                "color": "Color",
                "date": "Date",
                "file": "File",
                "text": "Text",
                "textarea": "Paragraph"
            },
            "typeHints": {
                "boolean": "The customer selects with an on/off toggle.",
                "select": "The customer selects a single option from a dropdown.",
                "color": "The customer picks one of the color options (as shown on variants).",
                "date": "The customer picks a date.",
                "file": "Customer uploads a file.",
                "text": "The customer enters a short text (256 characters).",
                "textarea": "The customer enters long text (2000 characters)."
            },
            "items": "Options",
            "addItem": "Add Option",
            "noItems": "No options added yet.",
            "itemLabel": "Label",
            "itemValue": "Value",
            "itemsRequired": "Enter at least one option for the select and color types.",
            "requiredLabel": "Make required",
            "requiredHint": "The customer cannot add the product to the cart without filling in this field.",
            "required": "Required",
            "dependsOn": "Dependency",
            "dependsOnHint": "This field is not shown to the customer until the selected field is filled in.",
            "noDependency": "Independent (always visible)",
            "sort": "Order",
            "free": "Free",
            "noPrices": "No price added — the field will be free."
        },
        "productAttributeValues": {
            "title": "Custom Fields",
            "description": "Enter the field values defined in the product's attribute set.",
            "set": "Set",
            "saveProductFirst": "Save the product first",
            "saveProductFirstHint": "You can enter custom field values here after the product is created.",
            "noFields": "No custom fields defined",
            "noFieldsHint": "No fields to show because no attribute set is assigned to this product. Sets are assigned via the category.",
            "saveValues": "Save Values",
            "invalidJson": "The {name} field does not contain valid JSON."
        },
        "productGallery": {
            "title": "Image Gallery",
            "description": "Select multiple images from the library; sort by dragging and set the poster.",
            "addImage": "Add Image",
            "adding": "Adding",
            "saveProductFirst": "Save the product first",
            "saveProductFirstHint": "After the product is created, you can manage the image gallery here.",
            "noImages": "No images yet",
            "noImagesHint": "You can select multiple images from the library and sort them by dragging.",
            "selectFromLibrary": "Select from Library",
            "dragToSort": "Drag to sort",
            "poster": "Poster",
            "makePoster": "Set as poster",
            "makePassive": "Set inactive",
            "makeActive": "Set active",
            "imagesAdded": "%s images added"
        },
        "productPackageItems": {
            "title": "Package Items",
            "description": "Manage the products this package will contain, along with their quantities and prices.",
            "addItem": "Add Item",
            "saveProductFirst": "Save the product first",
            "saveProductFirstHint": "After the product is created, you can add package items here.",
            "noItems": "No package items yet",
            "noItemsHint": "Add the products this package will contain with their quantities and prices.",
            "cols": {
                "product": "Product",
                "quantity": "Quantity",
                "price": "Price",
                "usage": "Usage"
            },
            "variant": "Variant",
            "selectVariant": "Select a variant combination",
            "variantHint": "If the package item product has more than one variant, select which one will be included.",
            "editItem": "Edit Package Item",
            "newItem": "New Package Item",
            "drawerSubtitle": "Product to be included in the package",
            "usageRule": "Usage Rule",
            "fixedDate": "Fixed Date",
            "dayCount": "Day Count",
            "usageDayCount": "Usage Day Count",
            "prices": "Prices",
            "addPrice": "Add Price",
            "noPrices": "No price added — the main product price applies.",
            "discounted": "Discounted",
            "cancel": "Cancel",
            "days": "days"
        },
        "productVariants": {
            "title": "Variants",
            "description": "Manage combinations such as color, size, etc., each with its own stock and price.",
            "stockReadonlyHint": "Variant stock is read-only; it only changes through Stock Management (purchase / adjustment / transfer / count).",
            "addCombination": "Add Combination",
            "saveProductFirst": "Save the product first",
            "saveProductFirstHint": "After the product is created, you can add variant combinations here.",
            "noVariants": "No variants yet",
            "noVariantsHint": "Add combinations such as color, size, etc., with their stock and prices.",
            "cols": {
                "combination": "Combination",
                "image": "Image",
                "stock": "Stock",
                "price": "Price"
            },
            "selectedCount": "{count} combinations selected",
            "deleteSelected": "Delete Selected",
            "deleteSelectedConfirm": "The selected {count} combinations will be deleted. Do you confirm?",
            "bulkCurrency": "Currency",
            "bulkApply": "Apply & Save",
            "listSeparately": "List variants separately",
            "listSeparatelyHint": "When enabled, each variant combination is shown as a separate product in the product list.",
            "listVariantGroup": "Listing variant group",
            "listVariantGroupHint": "A separate card is shown according to this group on the list page (e.g. Color). The other dimensions are selected on the product page.",
            "autoFirstGroup": "Automatic (first group)",
            "addImage": "Add Image",
            "manageImages": "Manage Images",
            "imageDrawerSubtitle": "Sort by dragging, add or remove",
            "noImages": "No images yet — add from the library.",
            "dragToSort": "Drag to sort",
            "inlineHint": "Edit stock and price from the table; edit images by clicking the image box and using the dialog that opens.",
            "generateTitle": "Generate Combinations",
            "generateSubtitle": "Select the values and let all combinations be created automatically",
            "generateHint": "All combinations of the selected values are created empty (stock 0, no price). Existing ones are skipped; you can enter stock and price later from the table.",
            "comboPreview": "{count} combinations will be created",
            "generateResult": "{created} combinations created, {skipped} already existed (skipped).",
            "generate": "Generate",
            "variantSelection": "Variant Selection",
            "noVariantTypes": "There are no variant types defined in this product group.",
            "prices": "Prices",
            "addPrice": "Add Price",
            "noPrices": "No price added — the main product price applies.",
            "discounted": "Discounted",
            "cancel": "Cancel"
        }
    },
    "customTable": {
        "noData": "No data found to list.",
        "showingPageInformationPattern": "Showing %d to %d of %s records"
    },
    "userMenu": {
        "language": "Language",
        "account": "My Account",
        "security": "Security",
        "userRoles": "Members & Roles",
        "integration": "Integrations",
        "darkMode": "Dark Mode",
        "signOut": "Sign Out"
    },
    "footer": {
        "copyrightText": "Ticatix E-Commerce Solutions. All rights reserved."
    },
    "endpointActions": {
        "get": "View",
        "post": "Create",
        "put": "Update",
        "delete": "Delete"
    },
    "responseErrors": {
        "record_not_found": "Record not found. It may have been deleted or moved elsewhere. Please search for a different record.",
        "method_not_found": "Operation not found. It may have been deleted or moved elsewhere. Please try again.",
        "invalid_file_type": "An invalid file type was selected. Please use an appropriate file type.",
        "current_password_invalid": "The current password is incorrect. Please enter the correct password and try again.",
        "this_group_not_usable": "This group is currently not usable. Please select a different group.",
        "invalid_identification_number": "An invalid ID number was entered. Please use a valid ID number.",
        "validate_error": "A validation error occurred. Please check your information and try again.",
        "provider_handler_not_found_by_code": "No provider was found for the specified code. Please enter a valid code.",
        "video_id_invalid": "You entered an invalid video ID. Please enter a valid ID.",
        "invalid_customer_id": "The customer number is incorrect. Please try again with a valid customer number.",
        "login_description": "Please sign in using the authorized login credentials sent to you.",
        "login_error": "Please check your login credentials.",
        "invalid_credentials": "Email or Password is incorrect. Please try again with valid credentials."
    },
    "topbar": {
        "search": "Search...",
        "notifications": "Notifications",
        "appsInstalled": "{n} installed",
        "appsEmpty": "No apps installed yet",
        "loading": "Loading...",
        "market": "Market",
        "searchHint": "Search products or customers…",
        "searchEmpty": "No results found",
        "searchMin": "Type at least 2 characters to search",
        "products": "Products",
        "customers": "Customers",
        "orders": "Orders",
        "categories": "Categories",
        "brands": "Brands",
        "coupons": "Coupons",
        "variantGroups": "Variant Types",
        "productGroups": "Product Groups",
        "suppliers": "Suppliers",
        "units": "Units",
        "attributeSets": "Attribute Sets",
        "tags": "Tags",
        "customerGroups": "Customer Groups",
        "discountCampaigns": "Discount Campaigns",
        "marketingCampaigns": "Marketing Campaigns",
        "automations": "Automations",
        "priceLists": "Price Lists",
        "salesChannels": "Sales Channels",
        "warehouses": "Warehouses",
        "menus": "Menus",
        "pages": "Pages",
        "notifEmpty": "No notifications yet",
        "notifMarkAll": "Mark all as read",
        "notifNew": "new",
        "notifAll": "All",
        "notifUnread": "Unread",
        "notifRead": "Read",
        "notifClearAll": "Clear all",
        "notifDelete": "Delete",
        "notifSwipeHint": "Swipe right to delete",
        "notifClearConfirm": "Delete all notifications?",
        "notifClearYes": "Yes, delete",
        "notifMarkAllShort": "Mark all read"
    }
};
